import {
  CModal,
  CModalBody,
  CModalFooter,
  CFormLabel,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CModalHeader,
  CModalTitle,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormTextarea,
  CCardBody,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CTable,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CSpinner,
} from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import './Patient.css'
import './dashboard.css'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SavePatients from '../../services/general/savePatientinformation.api'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api.js'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import Pageloader from '../../components/shared/Pageloader.jsx'
import PatientPopup from './PatientPopup.jsx'
import { motion } from 'framer-motion'
import { AlignLeft, CalendarCheck, FilePenLineIcon, Table2 } from 'lucide-react'
import { FunnelPlotOutlined } from '@ant-design/icons'
import PatientNoteDataCRUD from '../../../src/services/general/patientNoteData.api.js'
import toast from 'react-hot-toast'
import { toastConfig } from '../../../src/constants/other.config.js'
import { HiEye } from 'react-icons/hi'
import PatientSuperBillData from '../../services/general/patientSuperBill.api.js'
import RescheduleDatePicker from '../../components/shared/RescheduleDatePicker.jsx'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
import { getAllAppointments, getAllAppointmentsDetails, getAppointmentDataID } from '../../components/shared/appointmentFilterData.jsx'
import PatientAppointmentDetails from '../../services/general/appointmentData.api.js'
import PatientInfoSecond from './PatientinfoSecond.jsx'
import { checkIfDataAvailableData, convertToYYYYMMDD, getTodayDateKey } from '../../utils/checkForUpdateUtils.js'
import { usePatientStatus } from '../../hooks/usecheckForUpdate'
import { useLocation } from 'react-router-dom'
import { getFacilityParentCompany, getPatientFacilityParentCompany, normalizeSearchValue } from '../../utils/facilityParentCompany'
import AppSelect from '../../components/shared/AppSelect'

const formatScheduleDate = (date = new Date()) => {
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  const yyyy = date.getFullYear()
  return `${mm}/${dd}/${yyyy}`
}

let cachedSchedulePageProviders = null
let cachedSchedulePageProvidersPromise = null
let cachedSchedulePageInsurance = null
let cachedSchedulePageInsurancePromise = null
const PATIENT_NOTE_CHUNK_SIZE = 8

const getAppointmentScheduleDate = (appointment) => appointment?.data?.StartTime?.split?.(' ')?.[0] || ''
const APPOINTMENT_ALREADY_CANCELLED_MESSAGE = 'Appointment is already cancelled.'
const getAppointmentDateKey = (value) => String(value || '').split('T')[0].split(' ')[0]
const buildPatientDateKey = (patientId, scheduleDate) => `${String(patientId || '').trim()}::${getAppointmentDateKey(scheduleDate)}`
const buildPatientProviderDateKey = (patientId, providerId, scheduleDate) => `${String(patientId || '').trim()}::${String(providerId || '').trim()}::${getAppointmentDateKey(scheduleDate)}`
const getPatientAppointmentCacheKey = (appointment = {}) => {
  const patientId = appointment?.data?.PatientID ?? appointment?.current?.Patient?.value ?? ''
  const appointmentId = appointment?.data?.AppointmentID ?? ''
  const noteId = appointment?.data?.NoteID ?? ''
  const startTime = appointment?.data?.StartTime ?? ''
  return [patientId, appointmentId, noteId, startTime].filter(Boolean).join('::')
}
const chunkItems = (items = [], chunkSize = PATIENT_NOTE_CHUNK_SIZE) => {
  const chunks = []

  for (let index = 0; index < items.length; index += chunkSize) {
    chunks.push(items.slice(index, index + chunkSize))
  }

  return chunks
}

const buildGroupedAppointmentData = (appointmentList = []) => {
  const groupedByPatient = new Map()

  appointmentList.forEach((entry) => {
    const patientID = entry?.current?.Patient?.value
    if (patientID === undefined || patientID === null) return

    if (!groupedByPatient.has(patientID)) {
      groupedByPatient.set(patientID, {
        patientID,
        appointmentDetails: [],
      })
    }

    groupedByPatient.get(patientID).appointmentDetails.push({
      data: entry.data,
      current: entry.current,
    })
  })

  return Array.from(groupedByPatient.values())
}

const appointmentMatchesSearch = (patient, searchValue) => {
  const normalizedSearchValue = normalizeSearchValue(searchValue)

  if (!normalizedSearchValue) return true

  const fullName = [patient?.FirstName, patient?.MiddleName, patient?.LastName].filter(Boolean).join(' ')
  const firstLastName = [patient?.FirstName, patient?.LastName].filter(Boolean).join(' ')

  const searchableFields = [
    fullName,
    firstLastName,
    patient?.FirstName,
    patient?.MiddleName,
    patient?.LastName,
    patient?.FacilityName,
    patient?.facilityParentCompany,
    patient?.Room,
    patient?.DOB,
    patient?.PhoneNumber,
    patient?.PatientID,
    patient?.providerAssigned,
    patient?.current?.Provider?.label,
    patient?.data?.ProviderName,
    patient?.data?.AppointmentID,
    patient?.data?.StartTime,
    patient?.data?.Status,
    patient?.data?.Type,
    patient?.patientTerm,
  ]

  return searchableFields.some((field) => normalizeSearchValue(field).includes(normalizedSearchValue))
}

/* eslint-disable react/prop-types */
const ActionDropdown = ({ patient, index, handleAppointment, openRescheduleModal }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const triggerRef = useRef(null)
  const menuRef = useRef(null)
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 })

  const updateMenuPosition = () => {
    if (!triggerRef.current) return

    const triggerRect = triggerRef.current.getBoundingClientRect()
    const menuWidth = menuRef.current?.offsetWidth || 180
    const viewportPadding = 12
    const maxLeft = Math.max(viewportPadding, window.innerWidth - menuWidth - viewportPadding)
    const left = Math.min(Math.max(triggerRect.right - menuWidth, viewportPadding), maxLeft)

    setMenuPosition({
      top: triggerRect.bottom + 8,
      left,
    })
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideTrigger = dropdownRef.current && dropdownRef.current.contains(event.target)
      const clickedInsideMenu = menuRef.current && menuRef.current.contains(event.target)

      if (!clickedInsideTrigger && !clickedInsideMenu) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if (!isOpen) return

    updateMenuPosition()

    const handleWindowUpdate = () => updateMenuPosition()

    window.addEventListener('resize', handleWindowUpdate)
    window.addEventListener('scroll', handleWindowUpdate, true)

    return () => {
      window.removeEventListener('resize', handleWindowUpdate)
      window.removeEventListener('scroll', handleWindowUpdate, true)
    }
  }, [isOpen])

  const toggleDropdown = (e) => {
    e.stopPropagation()
    if (!isOpen) {
      updateMenuPosition()
    }
    setIsOpen((prev) => !prev)
  }

  return (
    <div className="position-relative d-inline-block" ref={dropdownRef}>
      <CButton
        ref={triggerRef}
        variant="outline"
        color="dark"
        className="calendar-button px-2"
        onClick={toggleDropdown}
      >
        <CalendarCheck size={20} />
      </CButton>
      {isOpen && createPortal(
        <div
          ref={menuRef}
          className="custom-action-menu patient-theme-action-menu"
          style={{
            position: 'fixed',
            top: menuPosition.top,
            left: menuPosition.left,
          }}
        >
          {patient?.data?.Status !== 'Canceled' && (
            <div
              role="button"
              className="custom-action-item patient-theme-action-item"
              onClick={(e) => { e.stopPropagation(); setIsOpen(false); handleAppointment(patient?.data?.AppointmentID, 'cancel', patient?.PatientID, patient) }}
            >
              Cancel
            </div>
          )}
          <div
            role="button"
            className="custom-action-item patient-theme-action-item"
            onClick={(event) => { event.stopPropagation(); setIsOpen(false); openRescheduleModal(patient, index, event) }}
          >
            Reschedule
          </div>
          <div
            role="button"
            className="custom-action-item patient-theme-action-item"
            onClick={(e) => { e.stopPropagation(); setIsOpen(false); handleAppointment(patient?.data?.AppointmentID, 'delete', patient?.PatientID, patient) }}
          >
            Delete
          </div>
        </div>,
        document.body
      )}
    </div>
  )
}

const Appointments2 = () => {
  const [patientIDClicked, setPatientIDClicked] = useState(-1)
  const [rowClicked, setRowClicked] = useState(null)
  const [selectedFacility, setSelectedFacility] = useState({})
  const [roomNumber, setRoomNumber] = useState('')
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [addedInsurances, setAddedInsurances] = useState([])
  const [insuranceList, setInsuranceList] = useState([])
  const [boxView, setBoxView] = useState('list')
  const [selectedDetails, setSelectedDetails] = useState({})
  const [patientID, setPatientID] = useState('')
  const [diagnosisData, setDiagnosisData] = useState([])
  var selectedDiagnosis = []
  const [allSelectedDiagnosis, setAllSelectedDiagnosis] = useState([])
  const [facilities, setFacilities] = useState([])
  const [patientData, setPatientData] = useState('')
  const [patientCount, setPatientCount] = useState(-1)
  const [patientInfoCount, setPatientInfoCount] = useState({
    followUp: 0,
    newPatient: 0,
  })
  const [providerList, setProviderList] = useState([])
  const [rescheduleProviders, setRescheduleProviders] = useState([])

  const [viewPatientDetail, setViewPatientDetail] = useState()
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [patientModelVisible, setPatientModalVisible] = useState(false)
  const [dataCallType, setDataCallType] = useState(null)
  const [setDataId, setEditDataId] = useState(null)
  const [showPatientInfo, setShowPatientInfo] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deletePatientID, setDeletePatientID] = useState(null)
  const [appointment, setAppointment] = useState([])
  const [appointments, setAppointments] = useState([])
  const [noteID, setNoteID] = useState(null)
  const [cancelModel, setCancelModel] = useState(false)
  const [finishModel, setFinishModel] = useState(false)
  const [appointmentID, setAppointmentID] = useState(null)
  const [allAppointment, setAllAppointment] = useState([])
  const [noteStatus, setNoteStatus] = useState('New Note')
  const [noteButtonContext, setNoteButtonContext] = useState('dashboard')
  const [patientAppointmentID, setPatientAppointmentID] = useState(null)
  const [patientId, setPatientId] = useState(null)
  const [creatingNewNote, setCreatingNewNote] = useState(false)
  const [superBill, setSuperBill] = useState([])
  const [scheduleTime, setScheduleTime] = useState(null)
  const [deleteModel, setDeleteModel] = useState(false)
  const [childformData, setChildFormData] = useState({
    FirstName: '',
    MiddleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Age: '0',
    PhoneNumber: '',
    EmergencyName: '',
    EmergencyPhone: '',
    Address: '',
    State: '',
    City: '',
    ZipCode: '',
    Country: '',
    insurance: '',
  })

  const [daysMap, setDaysMap] = useState({})
  const [locations, setLocations] = useState([])
  const [cancelReason, setCancelReason] = useState('')

  const { updatePatientData, addPatient, appendPatientInTodaysList } = usePatientStatus()
  const appointmentRequestRef = useRef(0)
  const initialPageDataLoadedRef = useRef(false)
  const providerListLoadedRef = useRef(false)
  const providerListRequestRef = useRef(null)
  const providerScheduleLoadedRef = useRef(false)
  const providerScheduleRequestRef = useRef(null)
  const patientNotesCacheRef = useRef(new Map())
  const patientNotesRequestRef = useRef(new Map())
  const appointmentNoteMetaCacheRef = useRef(new Map())
  const patientTreatmentRequestRef = useRef(0)


  console.log('cachedSchedulePageProviders', providerListRequestRef)
  const patientSelected = async (rowSelected) => {
    getData()
    setViewPatientDetail(rowSelected)
s
    let patientInsurance = await PatientInsuranceFn('SELECTALL', '', rowSelected.PatientID)

    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
    } catch (e) { }

    try {
      let tempSelectedDiagnosis = rowSelected.Diagnosis ? rowSelected.Diagnosis.split(',') : []
      selectedDiagnosis = diagnosisData.filter((obj) => tempSelectedDiagnosis.includes(obj.label))
      setRoomNumber(rowSelected?.Room)
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      setSelectedFacility(userFacilities ? userFacilities : facilities[0])
      setAllSelectedDiagnosis(selectedDiagnosis)
    } catch (e) {
      setAllSelectedDiagnosis([])
    }

    setChildFormData({
      FirstName: rowSelected.FirstName || '',
      MiddleName: rowSelected.MiddleName || '',
      LastName: rowSelected.LastName || '',
      DOB: rowSelected.DOB || '',
      Gender: rowSelected.Gender || '',
      Age: rowSelected.Age || '0',
      PhoneNumber: rowSelected.PhoneNumber || '',
      EmergencyName: rowSelected.EmergencyName || '',
      EmergencyPhone: rowSelected.EmergencyPhone || '',
      Address: rowSelected.Address || '',
      State: rowSelected.State || '',
      City: rowSelected.City || '',
      ZipCode: rowSelected.ZipCode || '',
      Country: rowSelected.Country || '',
    })

    setSelectedDetails({ Insurances: patientInsurance })
  }

  const openTreatmentNote = (rowSelected, appointmentID) => {
    setPatientID(rowSelected?.PatientID)
    localStorage.setItem('setPatientIDLocal', rowSelected?.PatientID)
    setPatientIDClicked(rowSelected?.PatientID)
    localStorage.setItem('setPatientIDClickedLocal', rowSelected?.PatientID)
    setRowClicked(rowSelected)
    localStorage.setItem('setRowClickedLocal', JSON.stringify(rowSelected))
    setPatientModalVisible(true)
    localStorage.setItem('setPatientModalVisibleLocal', true)
    setPatientAppointmentID(appointmentID)
    localStorage.setItem('setPatientAppointmentIDLocal', appointmentID)
    localStorage.setItem('setEditDataIdLocal', setDataId)
  }
  // const getAppointmentData = async () => {
  //     setIsPageLoading(true)
  //     try {

  //         let data = await SaveExtra('Get_By_Type', 'AppointmentsData', '', '')
  //         data = JSON.parse(data.d)?.Data || [];

  //         if (data) {
  //             data = data?.map((item) => {
  //                 return {
  //                     Id: item.Id,
  //                     Data: JSON.parse(item?.JsonData)
  //                 }
  //             })

  //         }
  //         setAppointmentDataID(data)
  //         setAppointments(data[0]?.Data)
  //         return data[0]?.Data || []
  //     } catch (error) {
  //         console.log(error)
  //     } finally {
  //         setIsPageLoading(false);

  //     }
  // };

  const clearAppointmentData = () => {
    setAllAppointment([])
    setAppointments([])
    setAppointment([])
    setPatientData([])
    setFilteredPatientData([])
    setUpdatedFilteredPatients([])
    setGroupedUpdatedFilteredPatients({})
    setIsAppointmentGroupingReady(false)
    setIsTreatmentNotesReady(false)
    setPatientCount(0)
    setPatientInfoCount({
      followUp: 0,
      newPatient: 0,
    })
  }

  const fetchAppointmentsByDate = async (scheduleDate) => {
    let appointmentDetails = []

    if (!scheduleDate) {
      appointmentDetails = await getAllAppointmentsDetails('GET')
    } else {
      appointmentDetails = await getAllAppointmentsDetails('GETBYSCHEDULEDATE', scheduleDate, '')
    }

    return {
      appointmentData: buildGroupedAppointmentData(appointmentDetails || []),
      appointmentDetails: appointmentDetails || [],
    }
  }

  const [hasNotAppointment, setHasNotAppointment] = useState(false)
  const patientDataFn = async (scheduleDate = filterData?.scheduleDate || formatScheduleDate()) => {
    const requestId = appointmentRequestRef.current + 1
    appointmentRequestRef.current = requestId
    setIsAppointmentGroupingReady(false)
    setIsTreatmentNotesReady(false)

    console.log('patientDataFn', scheduleDate)
    if (!scheduleDate) {
      clearAppointmentData()
    }

    setIsPageLoading(true)
    try {
      const [patientDataResponse, appointmentResult] = await Promise.all([SavePatients('GetAll', '', '', ''), fetchAppointmentsByDate(scheduleDate)])

      if (requestId !== appointmentRequestRef.current) return []

      const patient = JSON.parse(patientDataResponse.d)?.Data || []
      const appointmentsForDate = appointmentResult.appointmentDetails || []
      const patientIdsWithAppointments = new Set(appointmentsForDate.map((item) => String(item?.current?.Patient?.value ?? item?.data?.PatientID ?? '')))
      const schedulePatient = patient.filter((patientItem) => patientIdsWithAppointments.has(String(patientItem.PatientID)))
      console.log('appointmentHasNotAppointment', appointmentsForDate,schedulePatient)
      setPatientData(schedulePatient)
      setAllAppointment(appointmentResult.appointmentData || [])
      setAppointments(appointmentsForDate)
      setAppointment(appointmentsForDate)
      setHasNotAppointment(appointmentsForDate.length === 0)
      return appointmentsForDate
    } catch (error) {
      console.log(error)
      return []
    } finally {
      if (requestId === appointmentRequestRef.current) {
        setIsPageLoading(false)
      }
    }
  }
  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)

    let insuranceData = cachedSchedulePageInsurance

    if (!insuranceData) {
      if (!cachedSchedulePageInsurancePromise) {
        cachedSchedulePageInsurancePromise = fetchPatientData('GET', 'Insurance', '{}')
      }

      try {
        const insuranceResponse = await cachedSchedulePageInsurancePromise
        insuranceData = JSON.parse(insuranceResponse.d)?.Data || []
        cachedSchedulePageInsurance = insuranceData
      } finally {
        cachedSchedulePageInsurancePromise = null
      }
    }

    insuranceData = Array.isArray(insuranceData) ? insuranceData : []

    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))
    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
  }

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = (data || []).map((facility) => ({
        value: facility.ID,
        label: facility.Name,
        parentCompany: getFacilityParentCompany(facility),
      }))
      setFacilities(formattedData)
      setSelectedFacility(formattedData[0])
    } catch (e) { }
  }

  const patientSelectedFacility = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)

      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) { }
  }

  const saveDiagnosisData = async (customData) => {
    let a = {}
    let facility = await patientSelectedFacility(customData)

    try {
      a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
      a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
      a['Room'] = customData?.Room?.toString() || roomNumber.toString()
    } catch (e) {
      a['FacilityID'] = ''
      a['FacilityName'] = ''
      a['Room'] = -1
    }

    // let allDiagnosis = allSelectedDiagnosis.map(obj => { return obj.label }).join(",");

    let allDiagnosis = customData?.Diagnosis || ''

    let insurances = addedInsurances.map((ins) => ({
      InsuranceID: ins?.ID,
    }))

    let savePatientInfo
    if (patientID && patientID !== '') {
      savePatientInfo = SavePatients('Update', JSON.stringify(customData ? customData : childformData), JSON.stringify(a), allDiagnosis, patientID, JSON.stringify(insurances))
    }

    // await savePatientInfo;

    await patientDataFn()
    // resetStates()
  }

  useEffect(() => {
    if (initialPageDataLoadedRef.current) return
    initialPageDataLoadedRef.current = true
    getData()
    getFacilities()
  }, [])

  const noteStructureRef = useRef({})

  // if (rowClicked) {
  //   let provideInformation = rowClicked.Diagnosis.split(',');
  //   let information = provideInformation.map((item) => {
  //     return (
  //       { diagnosis: item, information: 'patient' }
  //     )
  //   })

  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     information,
  //   }

  // }

  const handleDeletePatient = async () => {
    let patientData = await SavePatients('Delete', '', '', '', deletePatientID, '')
    await patientDataFn()
    setDeletePatientID(null)
    setDeleteVisible(false)
  }

  const handleClicksPatiens = (patient) => {
    setPatientIDClicked(patient?.PatientID)
    setPatientID(patient?.PatientID)
    setRowClicked(patient)
    setShowPatientInfo(true)
  }
  const [showFilter, setShowFilter] = useState(false)
  const location = useLocation()

  const [filterData, setFilterData] = useState(() => {
    const defaultState = {
      facility: [],
      scheduleDate: formatScheduleDate(),
      searchValue: '',
      date: '',
      status: [],
      providers: [],
      appointmentStatus: ['Scheduled', 'Rescheduled'],
    }

    if (location?.state?.providerName) {
      defaultState.providers = [location.state.providerName]
      defaultState.scheduleDate = ''
    }

    return defaultState
  })

  const [filteredPatientData, setFilteredPatientData] = useState([]) // ✅ Make it a state

  const selectStatusOption = [
    { value: 'NewPatient', label: 'New Patient' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Re Admit', label: 'Re Admit' },
  ]

  const selectAppointmentStatus = [
    { value: 'Scheduled', label: 'Scheduled' },
    { value: 'Rescheduled', label: 'Rescheduled' },
    { value: 'Canceled', label: 'Cancelled' },
  ]

  useEffect(() => {
    patientDataFn(filterData.scheduleDate)
  }, [filterData.scheduleDate])

  const getPatientNotesById = async (patientId) => {
    const normalizedPatientId = String(patientId || '').trim()
    if (!normalizedPatientId) return []

    if (patientNotesCacheRef.current.has(normalizedPatientId)) {
      return patientNotesCacheRef.current.get(normalizedPatientId) || []
    }

    if (patientNotesRequestRef.current.has(normalizedPatientId)) {
      return patientNotesRequestRef.current.get(normalizedPatientId)
    }

    const requestPromise = (async () => {
      try {
        const dataResponse = await PatientNoteDataCRUD('GET', normalizedPatientId)
        const parsedData = JSON.parse(dataResponse?.d)?.Data || []
        patientNotesCacheRef.current.set(normalizedPatientId, parsedData)
        return parsedData
      } catch (err) {
        console.error(`Error fetching notes for patient ${normalizedPatientId}:`, err)
        patientNotesCacheRef.current.set(normalizedPatientId, [])
        return []
      } finally {
        patientNotesRequestRef.current.delete(normalizedPatientId)
      }
    })()

    patientNotesRequestRef.current.set(normalizedPatientId, requestPromise)
    return requestPromise
  }

  const getAppointmentNoteMeta = async (appt) => {
    const appointmentCacheKey = getPatientAppointmentCacheKey(appt)

    if (appointmentNoteMetaCacheRef.current.has(appointmentCacheKey)) {
      return appointmentNoteMetaCacheRef.current.get(appointmentCacheKey)
    }

    const patientId = appt?.data?.PatientID ?? appt?.current?.Patient?.value
    const parsedData = await getPatientNotesById(patientId)
    const noteIdForThisAppointment = appt?.data?.NoteID
    const findNote = parsedData.find((note) => note?.id === noteIdForThisAppointment)
    let noteData = findNote?.data || {}

    if (typeof noteData === 'string') {
      try {
        noteData = JSON.parse(noteData)
      } catch {
        noteData = {}
      }
    }

    const rawNoteStatus = String(findNote?.status || findNote?.Status || '').trim()
    const noteStatus = rawNoteStatus.toLowerCase() === 'signed' || noteData?.signedAt || noteData?.signatureInfo?.signedDate ? 'Signed' : rawNoteStatus || 'Not Created'

    const noteMeta = {
      noteStatus,
      noteFlag: findNote?.flag || 'false',
    }

    appointmentNoteMetaCacheRef.current.set(appointmentCacheKey, noteMeta)
    return noteMeta
  }

  const buildRenderedPatientAppointment = async (appt) => {
    if (appt?.data?.Status === 'Signed' || appt?.data?.Status === 'Finish') return null

    const appointmentPatientID = appt?.data?.PatientID ?? appt?.current?.Patient?.value
    const patient = patientData.find((p) => String(p.PatientID) === String(appointmentPatientID))

    if (!patient) return null

    const noteMeta = await getAppointmentNoteMeta(appt)
    if (noteMeta?.noteStatus === 'Signed') return null

    const patientWithAppointment = {
      ...patient,
      ...appt,
    }

    return {
      ...patientWithAppointment,
      noteStatus: noteMeta?.noteStatus || 'Not Created',
      noteFlag: noteMeta?.noteFlag || 'false',
      providerAssigned: appt?.current?.Provider?.label,
      scheduleStartTime: appt?.data?.StartTime,
      appointmentStatus: appt?.data?.Status,
      patientTerm: appt?.data?.term || '',
      facilityParentCompany: getPatientFacilityParentCompany(patientWithAppointment, facilities),
      ...(typeof appt?.data?.patientSeen === 'boolean' && {
        patientSeen: appt.data.patientSeen,
        notSeenReason: appt.data.notSeenReason,
      }),
    }
  }

  const GetPatientTreatmentsNotes = async () => {
    if (!patientData || !appointment) return

    const requestId = patientTreatmentRequestRef.current + 1
    patientTreatmentRequestRef.current = requestId
    setIsTreatmentNotesReady(false)

    try {
      const appointmentsToRender = (appointment || []).filter((appt) => {
        if (!appt || appt?.data?.Status === 'Signed' || appt?.data?.Status === 'Finish') return false
        const appointmentPatientID = appt?.data?.PatientID ?? appt?.current?.Patient?.value
        return patientData.some((patientItem) => String(patientItem?.PatientID) === String(appointmentPatientID))
      })

      const updatedPatients = []
      const appointmentChunks = chunkItems(appointmentsToRender, PATIENT_NOTE_CHUNK_SIZE)

      for (const appointmentChunk of appointmentChunks) {
        const chunkResults = await Promise.all(
          appointmentChunk.map(async (appt) => {
            try {
              return await buildRenderedPatientAppointment(appt)
            } catch (err) {
              const patientId = appt?.data?.PatientID ?? appt?.current?.Patient?.value
              console.error(`Error building treatment note state for patient ${patientId}:`, err)
              return null
            }
          }),
        )

        if (requestId !== patientTreatmentRequestRef.current) return

        updatedPatients.push(...chunkResults.filter(Boolean))
      }

      if (requestId !== patientTreatmentRequestRef.current) return

      setIsAppointmentGroupingReady(false)
      setFilteredPatientData(updatedPatients)
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      toast.error('Error in patient treatment', toastConfig)
    } finally {
      if (requestId === patientTreatmentRequestRef.current) {
        setIsTreatmentNotesReady(true)
      }
    }
  }

  useEffect(() => {
    GetPatientTreatmentsNotes()
  }, [patientData, appointment, facilities])

  const [updatedFilteredPatients, setUpdatedFilteredPatients] = useState([])

  const getAllProviderData = async ({ force = false } = {}) => {
    if (!force) {
      if (providerListRequestRef.current) {
        return providerListRequestRef.current
      }
        console.log('cachedSchedulePageProviders', cachedSchedulePageProviders)
      if (cachedSchedulePageProviders) {
        setProviderList(cachedSchedulePageProviders)
        providerListLoadedRef.current = true
        return cachedSchedulePageProviders
      }

      if (providerListLoadedRef.current) {
        return providerList
      }
    }

    providerListRequestRef.current = (async () => {
      try {
        if (!force && cachedSchedulePageProvidersPromise) {
          let providerData = await cachedSchedulePageProvidersPromise
          providerData = JSON.parse(providerData.d)?.Data || []
          providerData = [...providerData].sort((providerA, providerB) =>
            String(providerA?.Name || '').trim().localeCompare(String(providerB?.Name || '').trim(), undefined, { sensitivity: 'base' }),
          )
          cachedSchedulePageProviders = providerData
          setProviderList(providerData)
          providerListLoadedRef.current = true
          return providerData
        }

        cachedSchedulePageProvidersPromise = fetchPatientData('SELECT', 'Provider', '{}')
        let providerData = await cachedSchedulePageProvidersPromise
        providerData = JSON.parse(providerData.d)?.Data || []
        providerData = [...providerData].sort((providerA, providerB) =>
          String(providerA?.Name || '').trim().localeCompare(String(providerB?.Name || '').trim(), undefined, { sensitivity: 'base' }),
        )

        console.log('providerData', providerData)
        cachedSchedulePageProviders = providerData
        setProviderList(providerData)
        providerListLoadedRef.current = true
        return providerData
      } catch (error) {
        console.log(error)
        return []
      } finally {
        cachedSchedulePageProvidersPromise = null
        providerListRequestRef.current = null
      }
    })()

    return providerListRequestRef.current
  }

  useEffect(() => {
    getAllProviderData()
  }, [])

  const buildProviderDaysMap = (providers = []) => {
    const nextDaysMap = {}
    const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

    providers.forEach((provider) => {
      let parsedCapacity = null
      const providerFacilities = Array.isArray(provider?.Facilities) ? provider.Facilities : []

      try {
        if (provider?.ProviderData && provider.ProviderData !== 'undefined') {
          parsedCapacity = JSON.parse(provider.ProviderData)
        }
      } catch (error) {
        console.error('Invalid JSON in ProviderData:', provider.ProviderData, error)
        parsedCapacity = null
      }

      allDays.forEach((day) => {
        if (!nextDaysMap[day]) nextDaysMap[day] = []

        let providerEntry = nextDaysMap[day].find((p) => p.ID === provider.ID)

        if (!providerEntry) {
          providerEntry = {
            ID: provider.ID,
            Name: provider.Name,
            Gender: provider.Gender,
            DOB: provider.DOB,
            Address: provider.Address,
            AddressDetails: provider.AddressDetails,
            Lat: provider.Lat,
            Lng: provider.Lng,
            Insurances: provider.Insurances,
            Facilities: [],
            Capacity: parsedCapacity,
          }
          nextDaysMap[day].push(providerEntry)
        }

        providerFacilities.forEach((facility) => {
          providerEntry.Facilities.push(facility)
        })
      })
    })

    return nextDaysMap
  }

  const getAllProviderDataWithDetails = async () => {
    try {
      const baseProviders = await getAllProviderData()
      const detailedProviders = await Promise.all((baseProviders || []).map((provider) => getAllProviderDetails({ ...provider })))
      return detailedProviders
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const ensureProviderScheduleData = async () => {
    if (providerScheduleRequestRef.current) {
      return providerScheduleRequestRef.current
    }

    if (providerScheduleLoadedRef.current) {
      return daysMap
    }

    providerScheduleRequestRef.current = (async () => {
      const detailedProviders = await getAllProviderDataWithDetails()
      const nextDaysMap = buildProviderDaysMap(detailedProviders)
      setDaysMap(nextDaysMap)
      providerScheduleLoadedRef.current = true
      return nextDaysMap
    })().finally(() => {
      providerScheduleRequestRef.current = null
    })

    return providerScheduleRequestRef.current
  }

  const [groupedUpdatedFilteredPatients, setGroupedUpdatedFilteredPatients] = useState({})
  const [isAppointmentGroupingReady, setIsAppointmentGroupingReady] = useState(false)
  const [isTreatmentNotesReady, setIsTreatmentNotesReady] = useState(false)

  const fileringPatientOnFilterChanges = async () => {
    const hasSearchValue = Boolean(normalizeSearchValue(filterData.searchValue))
    const selectedFacilityLabels = facilities.filter((facility) => filterData.facility.includes(facility.value)).map((facility) => facility.label)

    const updatedFilteredPatientss = (filteredPatientData || [])
      .filter((patient) => {
        const matchesFacility = filterData.facility.length === 0 || selectedFacilityLabels.includes(patient.FacilityName)

        const matchesProviders = filterData?.providers.length === 0 || filterData?.providers.includes(patient?.providerAssigned)

        const matchesStatus = filterData.status.length === 0 || filterData.status.includes(patient.Status)

        const matchesSearchValue = appointmentMatchesSearch(patient, filterData.searchValue)

        const matchesDate = !filterData.date || patient?.DOB === filterData.date

        // const patientDate = new Date(patient?.scheduleStartTime)
        // const formattedPatientDate = `${patientDate.getFullYear()}-${(patientDate.getMonth() + 1).toString().padStart(2, '0')}-${patientDate.getDate().toString().padStart(2, '0')}`

        const matchesSchedule = !filterData.scheduleDate || patient?.scheduleStartTime?.split?.(' ')?.[0] === filterData.scheduleDate

        const matchesAppointmentStatus = filterData?.appointmentStatus.length === 0 || filterData?.appointmentStatus.includes(patient?.appointmentStatus)

        // const matchesSchedule = !filterData.scheduleDate || patient?.scheduleStartTime === filterData.scheduleDate

        return matchesFacility && matchesStatus && matchesSearchValue && matchesDate && matchesProviders && matchesSchedule && matchesAppointmentStatus
      })
      .filter(Boolean)

    setUpdatedFilteredPatients(updatedFilteredPatientss)

    const groupedByDate = {}

    // updatedFilteredPatientss.forEach((patient) => {
    //   const providerName = patient?.providerAssigned
    //   const facility = patient?.FacilityName || 'Unknown'
    //   const date = patient.scheduleStartTime?.split(' ')[0] || ''

    //   if (!groupedByDate[date]) {
    //     groupedByDate[date] = {}
    //   }

    //   if (!groupedByDate[date][facility]) {
    //     groupedByDate[date][facility] = []
    //   }

    //     groupedByDate[date][facility].push(patient)
    // })

    const providersToShow = filterData?.providers?.length > 0 ? providerList.filter((p) => filterData.providers.includes(p.Name)) : providerList

    try {
      const groupedByDateProviderFacility = {}

      updatedFilteredPatientss.forEach((patient) => {
        const date = patient?.scheduleStartTime?.split?.(' ')?.[0] || 'Unknown Date'
        const providerName = patient?.providerAssigned || 'Unknown Provider'
        const facilityKey = patient?.FacilityName || 'Unknown Facility'

        groupedByDateProviderFacility[date] ||= {}

        if (!hasSearchValue) {
          providersToShow.forEach((p) => {
            const name = p?.Name
            if (!name) return

            groupedByDateProviderFacility[date][name] ||= {
              count: 0,
              facilities: {},
            }
          })
        }

        groupedByDateProviderFacility[date][providerName] ||= {
          count: 0,
          facilities: {},
        }

        const providerNode = groupedByDateProviderFacility[date][providerName]

        providerNode.facilities[facilityKey] ||= []

        providerNode.facilities[facilityKey].push(patient)

        providerNode.count += 1
      })

      const sortedGroupedByDateProviderFacility = Object.fromEntries(
        Object.entries(groupedByDateProviderFacility).map(([date, providers]) => [
          date,
          Object.fromEntries(
            Object.entries(providers).sort(([providerNameA], [providerNameB]) => providerNameA.localeCompare(providerNameB, undefined, { sensitivity: 'base' })),
          ),
        ]),
      )

      setGroupedUpdatedFilteredPatients(sortedGroupedByDateProviderFacility)
    } catch (error) {
      console.error('Grouping error:', error)
    }

    setPatientCount(updatedFilteredPatientss?.length)
    setPatientInfoCount({
      followUp: updatedFilteredPatientss.filter((item) => item?.Status === 'Follow Up').length,
      newPatient: updatedFilteredPatientss.filter((item) => item?.Status === 'NewPatient').length,
    })
    setIsAppointmentGroupingReady(true)
  }

  useEffect(() => {
    setIsAppointmentGroupingReady(false)
    fileringPatientOnFilterChanges()
  }, [filterData, filteredPatientData, facilities, providerList])

  // Patient Appointments
  const [showPatientAppointmentId, setShowPatientAppointmentId] = useState(null)
  const [patientAppointment, setPatientAppointment] = useState([])
  const [activeKey, setActiveKey] = useState(1)

  const GetSelectedPatientAppoint = async () => {
    try {
      const selectedAppointments = appointment.filter((appoint) => appoint?.data?.AppointmentID === showPatientAppointmentId) || []
      setPatientAppointment(selectedAppointments)
    } catch (error) {
      console.error('Error fetching patient appointments:', error)
      toast.error('Error fetching patient appointments', toastConfig)
    }
  }

  // const handleAppointmentSubmit = async () => {
  //     try {
  //         setIsPageLoading(true)
  //         let appointmentFilterData = appointments.filter(item => (item.data.AppointmentID !== appointmentID))
  //         await SaveExtra('Update', 'AppointmentsData', JSON.stringify(appointmentFilterData), appointmentDataID[0]?.Id);
  //          patientDataFn()

  //         if (cancelModel) {
  //             toast.success('Cancel Appointment Successfully', toastConfig)
  //         } else if(finishModel) {
  //             toast.success('Finish Appointment Successfully', toastConfig)
  //         }
  //         // toast.success('Cancel Appointment Successfully', toastConfig)
  //     } catch (error) {
  //         toast.error('Failed to save', toastConfig)
  //     } finally {
  //         setIsPageLoading(false)
  //         setCancelModel(false)
  //         setFinishModel(false)
  //         setAppointmentID(null)
  //     }
  // }

  const handleUpdatePatientStatus = async (customData, shouldRefresh = true) => {
    try {
      let a = {}
      let facility = await patientSelectedFacility(customData)

      try {
        a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
        a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
        a['Room'] = customData?.Room?.toString() || roomNumber.toString()
      } catch (e) {
        a['FacilityID'] = ''
        a['FacilityName'] = ''
        a['Room'] = -1
      }

      const updateStatus = {
        ...customData,
        Status: 'Follow Up',
      }

      // let allDiagnosis = allSelectedDiagnosis.map(obj => { return obj.label }).join(",");

      let allDiagnosis = customData?.Diagnosis || ''

      let insurances = addedInsurances.map((ins) => ({
        InsuranceID: ins?.ID,
      }))
      let savePatientInfo
      if (updateStatus?.PatientID && updateStatus?.PatientID !== '') {
        savePatientInfo = SavePatients('Update', JSON.stringify(updateStatus), JSON.stringify(a), allDiagnosis, updateStatus?.PatientID, JSON.stringify(insurances))
      }

      await savePatientInfo

      if (shouldRefresh) {
        await patientDataFn()
      }
    } catch (error) {
      console.log('error while updating patient Status', error)
    }
    // resetStates()
  }

  const handleAppointmentSubmit = async (type, appointmentID, patientId, patient) => {
    try {
      setIsPageLoading(true)
      await handleUpdatePatientStatus(patient, false)

      handlePatientNote('Signed', appointmentID, patientId)
      const appointmentData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
      const appointment = appointmentData.length > 0 ? appointmentData[0] : []
      let latestData
      if (appointmentData.length > 0) {
        latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value)
      } else {
        toast.error('No data found', appointmentData)
        return
      }

      let appointmentFilterData = latestData.map((item) => {
        if (item.data.AppointmentID === appointmentID) {
          const now = new Date()
          const formattedEndDate = now
            .toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
            .replace(',', '')
          return {
            ...item,
            data: {
              ...item.data,
              Status: type,
              EndTimezone: formattedEndDate,
            },
          }
        }
        return item
      })

      const groupedData = buildGroupedAppointmentData(appointmentFilterData)
      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value)
     

      if (ID) {
        await PatientAppointmentDetails('UPDATE', ID, getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value, JSON.stringify(groupedData))
      } else {
        toast.error('Appointment ID note found', toastConfig)
      }

      await patientDataFn()
      if (cancelModel) {
        toast.success('Finish Appointment Successfully', toastConfig)
      } else {
        // toast.success('Finish Appointment Successfully', toastConfig)
      }
      //  toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
      setCancelModel(false)
      setFinishModel(false)
      setAppointmentID(null)
    }
  }

  const handleDeleteSubmit = async () => {
    try {
      setIsPageLoading(true)
      // deletePatientNote(appointmentID, patientId)
      let appointmentFilterData = appointments.filter((item) => item.data.AppointmentID === appointmentID)
      if (appointmentFilterData.length === 0) {
        console.error('apoointment not found', appointmentID)
        return
      }
      const appointment = appointmentFilterData[0]
     
      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', getAppointmentScheduleDate(appointment), appointment?.current?.Provider.value)
      let filterAppointments = latestData.filter((item) => item.data.AppointmentID !== appointmentID)
         console.log('appointment', appointment,filterAppointments)
      const groupedData = buildGroupedAppointmentData(filterAppointments)

      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value)

      if (ID) {
        await PatientAppointmentDetails('UPDATE', ID, getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value, JSON.stringify(groupedData))
        toast.success('Delete Appointment Successfully', toastConfig)
      } else {
        toast.error('Appointment ID note found', toastConfig)
      }

      await patientDataFn()
    } catch (error) {
      toast.error('Failed to save', toastConfig)
      console.log('error data', error)
    } finally {
      setIsPageLoading(false)
      setDeleteModel(false)
      setAppointmentID(null)
      setPatientID(null)
    }
  }

  const handleAppointmentCancel = async (type) => {
    try {
      setIsPageLoading(true)
      // const ChangeNoteStatus = handlePatientNote('Canceled', appointmentID, patientId)
      const appointmentData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
      const appointment = appointmentData.length > 0 ? appointmentData[0] : []

      let latestData
      if (appointmentData.length > 0) {
        latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value)
      } else {
        toast.error('No data found', appointmentData)
        return
      }
      let appointmentFilterData = latestData.map((item) => {
        if (item.data.AppointmentID === appointmentID) {
          const now = new Date()
          const formattedEndDate = now
            .toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
            .replace(',', '')
          return {
            ...item,
            data: {
              ...item.data,
              Status: type,
              EndTimezone: formattedEndDate,
            },
          }
        }
        return item
      })

      const groupedData = buildGroupedAppointmentData(appointmentFilterData)
      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value)
      if (ID) {
        await PatientAppointmentDetails('UPDATE', ID, getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value, JSON.stringify(groupedData))
      } else {
        toast.error('Appointment ID note found', toastConfig)
      }

      // await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      await patientDataFn()
      toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
      setCancelModel(false)
      setFinishModel(false)
      setAppointmentID(null)
    }
  }

  const handleAddNoteId = async (noteID) => {
    try {
      setIsPageLoading(true)

      const selectedAppointments = appointments.filter((item) => item?.data?.AppointmentID === patientAppointmentID)
      if (selectedAppointments.length === 0) {
        console.error('appointment not found')
        return
      }

      const appointment = selectedAppointments[0]
      console.log("scheduleData", getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value)
      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value)

      let appointmentFilterData = latestData.map((item) => {
        if (item.data.AppointmentID === patientAppointmentID) {
          return {
            ...item,
            data: {
              ...item.data,
              NoteID: noteID,
            },
          }
        }
        return item
      })

      const groupedData = buildGroupedAppointmentData(appointmentFilterData)
      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value)
  console.log('appointment', appointment,appointmentFilterData, groupedData, ID)
      if (ID) {
        await PatientAppointmentDetails('UPDATE', ID, getAppointmentScheduleDate(appointment), appointment?.current?.Provider?.value, JSON.stringify(groupedData))
      } else {
        toast.error('Appointment ID note found', toastConfig)
      }
      // await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      await patientDataFn()

      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save Note Id', toastConfig)
      console.log('error', error)
    } finally {
      setIsPageLoading(false)
      setPatientAppointment([])
    }
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const handlePatientNote = async (type, appointmentID, patientId) => {
    try {
      if (!appointmentID || !patientId) {
        throw new Error('Missing appointmentId or patientId.')
      }

      const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)

      if (appointmentFilterData.length === 0) {
        throw new Error(`No appointment found with ID: ${appointmentID}`)
      }

      const noteID = appointmentFilterData[0]?.data?.NoteID

      if (!noteID) {
        throw new Error(`NoteID not found for appointment ID: ${appointmentID}`)
      }

      const dataResponse = await PatientNoteDataCRUD('GET', patientId)

      if (!dataResponse?.d) {
        throw new Error('No data received from PatientNoteDataCRUD GET.')
      }

      const parsedResponse = JSON.parse(dataResponse.d)
      const parsedData = parsedResponse?.Data

      if (!Array.isArray(parsedData)) {
        throw new Error('Parsed patient data is not a valid array.')
      }

      const findNote = parsedData.filter((item) => item.id === noteID)

      if (findNote.length === 0) {
        throw new Error(`No patient note found with ID: ${noteID}`)
      }

      const treatmentData = findNote[0]
      const id = treatmentData?.id

      if (!id) {
        throw new Error('Note ID is missing in the matched note.')
      }

      let data = {}

      try {
        data = treatmentData?.data ? JSON.parse(treatmentData.data) : {}
      } catch (e) {
        console.error('Invalid JSON in treatmentData.data:', e)
        data = {}
      }

      if (type === 'Canceled') {
        data.NoteCancelReason = cancelReason
      }

      await PatientNoteDataCRUD('UPDATE', patientId.toString(), id.toString(), JSON.stringify(data), getFormattedDate().toString(), type, 'true')

      setCancelReason('')
    } catch (err) {
      console.error('Error in handlePatientNote:', err.message || err)
      setCancelReason('')
    }
  }

  const deletePatientNote = async (appointmentID, patientId) => {
    try {
      if (!appointmentID || !patientId) {
        throw new Error('Missing appointmentId or patientId.')
      }

      const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)

      if (appointmentFilterData.length === 0) {
        throw new Error(`No appointment found with ID: ${appointmentID}`)
      }

      const noteID = appointmentFilterData[0]?.data?.NoteID
       console.log('parsedData-->',   appointmentFilterData , noteID)
      if (!noteID) {
        throw new Error(`NoteID not found for appointment ID: ${appointmentID}`)
      }

      const dataResponse = await PatientNoteDataCRUD('GET', patientId)

      if (!dataResponse?.d) {
        throw new Error('No data received from PatientNoteDataCRUD GET.')
      }

      const parsedResponse = JSON.parse(dataResponse.d)
      const parsedData = parsedResponse?.Data

      if (!Array.isArray(parsedData)) {
        throw new Error('Parsed patient data is not a valid array.')
      }
       
      const findNote = parsedData.filter((item) => item.id === noteID)

      if (findNote.length === 0) {
        throw new Error(`No patient note found with ID: ${noteID}`)
      }

      await PatientNoteDataCRUD('DELETE', patientID.toString(), noteID.toString())
    } catch (err) {
      console.error('Error in patient delete:', err.message || err)
    }
  }

  const getFacilitiesAppointment = async () => {
    let facilities = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(facilities.d)

    facilities = data.Data
    console.log('facilities', facilities)
    setLocations(facilities)
  }

  function formatDate(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  const GetPatientTreatmentsNotesStatus = async (patientID) => {
    setIsPageLoading(true)
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)
      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data.map((item) => {
          return {
            ...item,
            data: item.data ? JSON.parse(item?.data) : {},
          }
        })

        return data
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error in patient treatment:', error.message || error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const handleAppointment = async (appointmentID, type, patientId, patient) => {
    // const lastNoteStatus  = await GetPatientTreatmentsNotesStatus(patientId)
    // let lastNoteStatusData = false
    // if (lastNoteStatus && lastNoteStatus.length > 0) {
    //     const lastNote = lastNoteStatus[lastNoteStatus.length - 1]
    //     if (lastNote?.status === "Signed") {
    //         lastNoteStatusData  = true
    //     }
    // }

    if (type === 'cancel') {
      setCancelModel(true)
    } else if (type === 'Signed') {
      getSuperBillData(patientId)
      handleAppointmentSubmit('Signed', appointmentID, patientId, patient)
      setTimeout(() => {
        handleAutoSchedule(patient, appointmentID)
      }, 3000)
    } else if (type === 'delete') {
      setDeleteModel(true)
    }

    setAppointmentID(appointmentID)
    setPatientId(patientId)
    setSuperBill([])
  }

  const handleSubmit = async (updateData, apiCallType, selectedAppointments, type = null) => {
    try {
      setIsPageLoading(true)

      const groupedData = buildGroupedAppointmentData(updateData)
      const appointmentData = selectedAppointments
      const scheduleDate = getAppointmentScheduleDate(appointmentData)
      const providerId = appointmentData?.current?.Provider?.value
      const latestDateAppointments = await getAllAppointmentsDetails('GETBYSCHEDULEDATE', scheduleDate, '')
      const canceledConflicts = getCanceledConflictAppointments(updateData, latestDateAppointments || [])

      if (canceledConflicts.length > 0) {
        toast.error(APPOINTMENT_ALREADY_CANCELLED_MESSAGE, toastConfig)
        return
      }

      if (apiCallType == 'UPDATE') {
        const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', scheduleDate, providerId)
        await PatientAppointmentDetails('UPDATE', ID, scheduleDate, providerId, JSON.stringify(groupedData))
      } else {
        await PatientAppointmentDetails('INSERT', '', scheduleDate, providerId, JSON.stringify(groupedData))
      }
      // await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      // getAppointmentData();
      // await  getAppointmentData()
      await patientDataFn()
      //  await    GetPatientTreatmentsNotes()
      if (type == 'Rescheduled') {
        toast.success('Patient Rescheduled Successfully', toastConfig)
      } else {
        toast.success('Patient Auto Scheduled  Successfully', toastConfig)
      }
    } catch (error) {
      toast.error('Failed to Auto Scheduled', toastConfig)
    } finally {
      setIsPageLoading(false)
      setSelectDate(null)
      setShowRescheduleModal(false)
      setSelectedProvider(null)
      setShowLoader(false)
    }
  }

  // const getAllProviderDetails = async (obj) => {
  //     const provider = {
  //         ID: obj.ID
  //     };
  //     let providerData = await fetchPatientData("SELECTALL", "Provider", JSON.stringify(provider));
  //     let insuranceData = JSON.parse(providerData.d)?.Insurance;
  //     let facilityData = JSON.parse(providerData.d)?.Facility;
  //     setselectProviderInsurances(insuranceData)
  //     setselectProviderFacilities(facilityData)

  //     obj["Insurances"] = insuranceData
  //     obj["Facilities"] = facilityData

  //     return obj
  // }

  const getAllProviderDetails = async (obj) => {
    try {
      const provider = {
        ID: obj.ID,
      }

      let providerData = await fetchPatientData('SELECTALL', 'Provider', JSON.stringify(provider))

      let insuranceData = JSON.parse(providerData.d)?.Insurance
      let facilityData = JSON.parse(providerData.d)?.Facility

      obj['Insurances'] = insuranceData
      obj['Facilities'] = facilityData

      return obj
    } catch (error) {
      console.error('Error fetching provider details:', error)
      return obj // Optional: return the original object in case of failure
    }
  }

  // const getProviders = async () => {
  //   let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
  //   let data = JSON.parse(providerData.d)
  //   providerData = data.Data
  //   let newProviders = []
  //   for (let i = 0; i < providerData.length; i++) {
  //     let c = await getAllProviderDetails(providerData[i])
  //     newProviders.push(c)
  //   }

  //   const daysMap = {}

  //   // Iterate through the providers array
  //   newProviders.forEach((provider) => {
  //     // Iterate through each facility of the provider
  //     provider.Facilities.forEach((facility) => {
  //       // Split the Days string into an array of days
  //       const daysArray = facility.Days.split(',')

  //       // For each day in the daysArray, add the provider to the corresponding entry in the map
  //       daysArray.forEach((day) => {
  //         day = day.trim()
  //         if (!daysMap[day]) {
  //           daysMap[day] = []
  //         }

  //         // Find if the provider already exists in the day's list
  //         let providerEntry = daysMap[day].find((p) => p.ID === provider.ID)
  //         if (!providerEntry) {
  //           // Add the provider if not already in the list for that day
  //           providerEntry = {
  //             ID: provider.ID,
  //             Name: provider.Name,
  //             Gender: provider.Gender,
  //             DOB: provider.DOB,
  //             Address: provider.Address,
  //             AddressDetails: provider.AddressDetails,
  //             Lat: provider.Lat,
  //             Lng: provider.Lng,
  //             Insurances: provider.Insurances,
  //             Facilities: [],
  //           }
  //           daysMap[day].push(providerEntry)
  //         }

  //         // Add the facility to the provider's list of facilities
  //         providerEntry.Facilities.push(facility)
  //       })
  //     })
  //   })

  //   setDaysMap(daysMap)
  //   return newProviders
  // }

  const getProviders = async () => {
    const detailedProviders = await getAllProviderDataWithDetails()
    const nextDaysMap = buildProviderDaysMap(detailedProviders)
    setDaysMap(nextDaysMap)
    providerScheduleLoadedRef.current = true
    return detailedProviders
  }

  const allData = useRef({})

  // const handleSchedule = async (props, patient, oldData) => {
  //   if (!props?.StartTime || !props?.EndTime) return

  //   let scheduleAppointmentTime = await getSuperBillData(patient.PatientID)
  //   const weeksMatch = scheduleAppointmentTime?.match(/(\d+)\s*week/i)
  //   const weeksToAdd = weeksMatch ? parseInt(weeksMatch[1], 10) : 1
  //   let startTime = new Date(props.StartTime)
  //   let targetDate = new Date(startTime)
  //   targetDate.setDate(targetDate.getDate() + weeksToAdd * 7)
  //   const date = targetDate.toISOString().split('T')[0]
  //   const dayOptions = { weekday: 'long' }
  //   const day = targetDate.toLocaleDateString('en-US', dayOptions)

  //   try {
  //     const allDayData = daysMap[day]
  //     if (!allDayData) {
  //       console.warn(`No data found for ${day}.`)
  //       alert('No schedule available for this day.')
  //       return
  //     }

  //     allDayData.forEach((obj) => {
  //       obj.Facilities.forEach((facility) => {
  //         let tempFacility = locations.find((o) => o.ID == facility.FacilityID)
  //         facility['Name'] = tempFacility?.Name || ''
  //         facility['Type'] = tempFacility?.Type || ''
  //       })
  //     })

  //     const providerInfo = allDayData.filter((obj) => obj.Facilities.some((facility) => facility.Name === patient.FacilityName))
  //     if (providerInfo.length === 0) {
  //       console.warn(`No provider assigned to ${patient.FacilityName} on ${day}.`)
  //       alert('No providers are currently assigned to this facility on the selected day.')
  //       return
  //     } else {
  //       let provider = providerInfo.filter((item) => item?.ID === oldData?.current?.Provider?.value)

  //       if (provider.length === 0) {
  //         provider = providerInfo[0]
  //       } else {
  //         provider = provider[0]
  //       }
  //       allData.current.Provider = {
  //         value: provider?.ID,
  //         label: provider?.Name,
  //       }
  //       return targetDate
  //     }
  //   } catch (e) {
  //     console.error('Error processing schedule:', e)
  //   }
  // }

  const handleSchedule = async (scheduleProps, patient, oldData) => {
    const { StartTime, EndTime } = scheduleProps || {}
    if (!StartTime || !EndTime) return

    try {
      let scheduleAppointmentTime = await getSuperBillData(patient.PatientID)

      const weeksMatch = scheduleAppointmentTime?.match(/(\d+)\s*week/i)
      const weeksToAdd = weeksMatch ? parseInt(weeksMatch[1], 10) : 1

      let startTime = new Date(StartTime)
      let targetDate = new Date(startTime)
      targetDate.setDate(targetDate.getDate() + weeksToAdd * 7)

      const dayOptions = { weekday: 'long' }
      const day = targetDate.toLocaleDateString('en-US', dayOptions)

      const allDayData = daysMap[day]

      if (!allDayData) {
        console.warn(`No data found for ${day}.`)
        alert('No schedule available for this day.')
        return
      }

      allDayData.forEach((obj) => {
        obj.Facilities.forEach((facility) => {
          let tempFacility = locations.find((o) => o.ID == facility.FacilityID)
          facility['Name'] = tempFacility?.Name || ''
          facility['Type'] = tempFacility?.Type || ''
        })
      })

      const providerInfo = allDayData.filter((obj) => obj.Facilities.some((facility) => facility.Name === patient.FacilityName))

      if (providerInfo.length === 0) {
        console.warn(`No provider assigned to ${patient.FacilityName} on ${day}.`)
        alert(`No providers are currently assigned to ${patient.FacilityName} on ${day}.`)
        return
      }

      let provider = providerInfo.find((item) => item?.ID === oldData?.current?.Provider?.value)
      if (!provider) provider = providerInfo[0]

      allData.current.Provider = {
        value: provider?.ID,
        label: provider?.Name,
      }

      return targetDate
    } catch (e) {
      console.error('Error processing schedule:', e)
    }
  }

  const handleAutoSchedule = async (item, appointmentID) => {
    const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
    let patientInsurance = await PatientInsuranceFn('SELECT', '', item.PatientID)
    let tempAppointments = []
    let Insurance = {}
    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
      if (patientInsurance.length > 0) {
        Insurance = JSON.parse(patientInsurance[0].InsuranceDetails)
        Insurance = Insurance[0] || {}
      }
    } catch (e) { }
    try {
      let getPatientTime = await PatientNoteDataCRUD('GET', item.PatientID)
      getPatientTime = JSON.parse(getPatientTime.d)?.Data
      getPatientTime = getPatientTime.map((entry) => ({
        ...entry,
        getPatientTime: entry.getPatientTime ? JSON.parse(entry.getPatientTime) : {},
      }))
      if (getPatientTime) {
        await ensureProviderScheduleData()

        let rawDate = getPatientTime.length > 0 ? getPatientTime[0].date : new Date().toISOString().split('T')[0]
        let formattedDate = rawDate.replaceAll('.', '/')

        let props = {
          StartTime: appointmentFilterData.length > 0 ? appointmentFilterData[0]?.data.StartTime : formattedDate,
          EndTime: formattedDate,
          PatientID: item.PatientID,
        }

        const signedAppointment = appointmentFilterData[0]
        const signedAppointmentDate = getAppointmentScheduleDate(signedAppointment)
        let filtered = signedAppointmentDate ? await getAllAppointments('GETBYSCHEDULEDATEANDPROVIDERID', signedAppointmentDate, signedAppointment?.current?.Provider?.value || '') : []

        let oldData
        if (filtered.length > 0) {
          filtered = filtered.filter((entry) => entry.patientID === item.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Signed' || appt.data?.Status === 'Finish'))
          oldData = filtered[0]?.appointmentDetails.at(-1)
        }

        if (oldData?.data?.isInFacility === false) {
          alert(`Patient ${item.FirstName} ${item.LastName || ''} is not in the facility and cannot be scheduled.`)
          return
        }
        let updateOtherDetails = {}

        const priorAuth = oldData?.data?.otherDetails?.priorAuth
        if (priorAuth?.isRequired) {
          let noOfTimes = parseInt(priorAuth?.details?.noOfTimes, 10)

          if (isNaN(noOfTimes) || noOfTimes <= 0) {
            alert(`Patient ${item.FirstName} ${item.LastName || ''} has no remaining prior auth and cannot be scheduled.`)
            if (oldData?.data) {
              oldData.data.isInFacility = false
            }
            return
          } else {
            updateOtherDetails = {
              ...oldData.data.otherDetails,
              priorAuth: {
                ...priorAuth,
                details: {
                  ...priorAuth.details,
                  noOfTimes: `${noOfTimes - 1}`,
                },
              },
            }
          }
        }

        let scheduledDate = await handleSchedule(props, item, oldData)
        let organizeDate = formatDate(scheduledDate)

        let facility = locations?.find((facility) => facility.Name === item.FacilityName)

        let localPatient = { value: item.PatientID, label: `${item.FirstName} ${item.LastName}` }
        let localFacility = { value: facility?.ID, label: facility?.Name }
        let localProvider = allData.current?.Provider || {}

        let data = {
          AppointmentName: `${item.FirstName} ${item.LastName}`,
          StartTime: organizeDate,
          EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
          PatientID: item.PatientID,
          StartTimezone: null,
          EndTimezone: null,
          Facility: facility?.Name || '',
          Insurance: Insurance || {},
          Status: 'Scheduled',
          Notes: '',
          RoomNumber: item.Room,
          RecurrenceRule: '',
          VisitReason: 'F/U (Follow Up)',
          isInFacility: oldData ? oldData?.data?.isInFacility || true : true,
          otherDetails: oldData ? updateOtherDetails || {} : {},
          AppointmentID: Date.now(),
          ProviderName: localProvider?.label || '',
          ScheduleBy: 'auto-manuel',

          // PatientStatus: filtered.length > 0 ? 'Follow Up' :  item?.Status || 'NewPatient'
          Type: 'Follow Up',
          CreatedDate: new Date(),
          patientSeen: oldData ? oldData?.data?.patientSeen : true,
          notSeenReason: oldData ? oldData?.data?.notSeenReason : '',
          customReason: oldData ? oldData?.data?.customReason : '',

          // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
        }

        let details = {
          data,
          current: {
            Patient: localPatient,
            Facility: localFacility,
            Provider: localProvider,
            Insurance: Insurance,
          },
        }

        tempAppointments.push(details)
      } else {
        alert('Patient creation failed: Patient creation date not found. \n Hint: Try using manual-schedule to proceed.')
      }
    } catch (error) {
      console.error('Error fetching patient orders', error)
    }
    if (tempAppointments.length > 0) {
      const scheduleDate = getAppointmentDateKey(tempAppointments[0]?.data?.StartTime)
      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', scheduleDate, tempAppointments[0]?.current?.Provider?.value)
      const canceledLookupForDate = await getCanceledAppointmentLookupForDate(scheduleDate)
      const apiCallType = latestData.length > 0 ? 'UPDATE' : 'INSERT'
      const canceledDuplicates = tempAppointments.filter((appointment) =>
        canceledLookupForDate.has(buildPatientProviderDateKey(appointment?.data?.PatientID, appointment?.current?.Provider?.value, appointment?.data?.StartTime)),
      )

      if (canceledDuplicates.length > 0) {
        toast.error(APPOINTMENT_ALREADY_CANCELLED_MESSAGE, toastConfig)
        return
      }

      const combinedAppointments = [...latestData, ...tempAppointments]
      handleSubmit(combinedAppointments, apiCallType, tempAppointments[0])
    }
  }

  useEffect(() => {
    if (showPatientAppointmentId) {
      GetSelectedPatientAppoint()
    }
  }, [showPatientAppointmentId])

  useEffect(() => {
    getFacilitiesAppointment()
  }, [])

  useEffect(() => {
    const analyticDataSaved = localStorage.getItem('analyticsFilter')
    if (analyticDataSaved) {
      const parsedData = JSON.parse(analyticDataSaved)
      setFilterData((p) => {
        return {
          ...p,
          ...parsedData,
          scheduleDate: parsedData?.scheduleDate || formatScheduleDate(),
        }
      })
      localStorage.removeItem('analyticsFilter')
    }
  }, [])

  const getSuperBillData = async (patientID) => {
    try {
      let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientID.toString())
      data = JSON.parse(data?.d)?.Data || []

      if (data?.length) {
        data = data.map((item) => ({
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }))
      }

      setSuperBill(data)

      const lastItem = data?.at(-1)?.Data?.followUpTime ?? null

      setScheduleTime(lastItem)
      return lastItem
    } catch (error) {
      console.error('Error fetching Super Bill data:', error)
    }
  }

  const findDates = (allowedWeekdays) => {
    const weekdayMapping = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    }
    const allowedWeekdayNumbers = allowedWeekdays.map((day) => weekdayMapping[day])
    let today = new Date()
    let matchingDates = []

    for (let i = 0; i < 16; i++) {
      let currentDate = new Date(today)
      currentDate.setDate(today.getDate() + i)

      let currentWeekday = currentDate.getDay()

      if (allowedWeekdayNumbers.includes(currentWeekday)) {
        matchingDates.push(currentDate.toString())
      }
    }
    return matchingDates
  }

  const [selectDate, setSelectDate] = useState(null)
  const [selectedProvider, setSelectedProvider] = useState(null)

  const [showRescheduleModal, setShowRescheduleModal] = useState(false)
  const [rescheduleData, setRescheduleData] = useState({
    appointmentID: null,
    patientID: null,
    patient: null,
    index: null,
  })

  useEffect(() => {
    if (showRescheduleModal) {
      ensureProviderScheduleData()
    }
  }, [showRescheduleModal])

  useEffect(() => {
    if (!showRescheduleModal) return

    let isActive = true

    const loadRescheduleProviders = async () => {
      const detailedProviders = await getAllProviderDataWithDetails()
      if (isActive) {
        setRescheduleProviders(detailedProviders)
      }
      console.log("detailsProviders", detailedProviders)
    }
       
    loadRescheduleProviders()

    return () => {
      isActive = false
    }
  }, [showRescheduleModal])

  const openRescheduleModal = (patient, index, event) => {
    event?.preventDefault?.()
    event?.stopPropagation?.()

    setSelectDate(null)
    setSelectedProvider(null)
    setRescheduleData({
      appointmentID: patient?.data?.AppointmentID ?? null,
      patientID: patient?.PatientID ?? patient?.data?.PatientID ?? null,
      patient: patient || null,
      index: Number.isInteger(index) ? index : null,
    })
    setRescheduleProviders([])

    // Let the dropdown finish closing before opening the modal.
    requestAnimationFrame(() => {
      setShowRescheduleModal(true)
    })
  }

  // const handleDeleteScheduleAppointment = async (appointmentID) => {
  //   try {
  //     const groupedData = []
  //     let appointmentFilterData = appointments.filter((item) => item.data.AppointmentID === appointmentID)
  //     if (appointmentFilterData.length === 0) {
  //       console.error('apoointment not found')
  //     }

  //     const appointment = appointmentFilterData[0]

  //     const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', appointment?.data?.StartTime.split(' ')[0], appointment?.current?.Provider.value)
  //     let filterAppointments = latestData.filter((item) => item.data.AppointmentID !== appointmentID)

  //     filterAppointments.forEach((entry) => {
  //       const patientID = entry.current.Patient.value

  //       const existing = groupedData.find((item) => item.patientID === patientID)

  //       if (existing) {
  //         existing.appointmentDetails.push({ data: entry.data, current: entry.current })
  //       } else {
  //         groupedData.push({
  //           patientID,
  //           appointmentDetails: [{ data: entry.data, current: entry.current }],
  //         })
  //       }
  //     })
  //     const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)

  //     if (ID) {
  //       await PatientAppointmentDetails('UPDATE', ID, appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value, JSON.stringify(groupedData))
  //       // toast.success('Delete Appointment Successfully', toastConfig)
  //     } else {
  //       console.error('Appointment ID note found')
  //       // toast.error('Appointment ID note found', toastConfig)
  //     }
  //   } catch (error) {
  //     // toast.error('Failed to save', toastConfig)
  //     console.log('error data', error)
  //   }
  // }

  const handleDeleteScheduleAppointment = async (appointmentID) => {
    try {
      let appointmentFilterData = appointments.filter((item) => item.data.AppointmentID === appointmentID)

      if (appointmentFilterData.length === 0) {
        console.error('appointment not found')
        return false
      }

      const appointment = appointmentFilterData[0]
      const scheduleDate = getAppointmentScheduleDate(appointment)
      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', scheduleDate, appointment?.current?.Provider.value)
      const filterAppointments = latestData.filter((item) => item.data.AppointmentID !== appointmentID)
      const groupedData = buildGroupedAppointmentData(filterAppointments)
      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', scheduleDate, appointment?.current?.Provider?.value)

      if (!ID) {
        console.error('Appointment ID not found')
        return false
      }

      await PatientAppointmentDetails('UPDATE', ID, scheduleDate, appointment?.current?.Provider?.value, JSON.stringify(groupedData))
      return true
    } catch (error) {
      console.log('error data', error)
      return false
    }
  }

  const hasCanceledAppointmentOnDate = (patientId, scheduleDate, providerId = '') => {
    const normalizedPatientId = String(patientId || '').trim()
    const normalizedScheduleDate = getAppointmentDateKey(scheduleDate)
    const normalizedProviderId = String(providerId || '').trim()

    if (!normalizedPatientId || !normalizedScheduleDate) return false

    return appointments.some((appointment) => {
      const appointmentPatientId = String(appointment?.data?.PatientID || appointment?.current?.Patient?.value || '').trim()
      const appointmentStatus = String(appointment?.data?.Status || '').trim().toLowerCase()
      const appointmentDate = getAppointmentDateKey(getAppointmentScheduleDate(appointment))
      const appointmentProviderId = String(appointment?.current?.Provider?.value || '').trim()

      return (
        appointmentPatientId === normalizedPatientId &&
        appointmentStatus === 'canceled' &&
        appointmentDate === normalizedScheduleDate &&
        (!normalizedProviderId || appointmentProviderId === normalizedProviderId)
      )
    })
  }

  const getCanceledAppointmentLookupForDate = async (scheduleDate) => {
    const normalizedScheduleDate = getAppointmentDateKey(scheduleDate)

    if (!normalizedScheduleDate) {
      return new Set()
    }

    const latestAppointments = await getAllAppointmentsDetails('GETBYSCHEDULEDATE', normalizedScheduleDate, '')

    return new Set(
      (latestAppointments || [])
        .filter((item) => String(item?.data?.Status || '').trim().toLowerCase() === 'canceled')
        .map((item) => buildPatientProviderDateKey(
          item?.data?.PatientID || item?.current?.Patient?.value,
          item?.current?.Provider?.value,
          getAppointmentScheduleDate(item),
        )),
    )
  }

  const getCanceledConflictAppointments = (candidateAppointments = [], existingAppointments = []) => {
    return candidateAppointments.filter((appointment) => {
      const status = String(appointment?.data?.Status || '').trim().toLowerCase()
      if (status !== 'scheduled' && status !== 'rescheduled') return false

      const patientId = String(appointment?.data?.PatientID || '').trim()
      const scheduleDate = getAppointmentDateKey(getAppointmentScheduleDate(appointment))
      const appointmentId = String(appointment?.data?.AppointmentID || '').trim()
      const providerId = String(appointment?.current?.Provider?.value || '').trim()

      return existingAppointments.some((existingAppointment) => {
        const existingStatus = String(existingAppointment?.data?.Status || '').trim().toLowerCase()
        const existingPatientId = String(existingAppointment?.data?.PatientID || '').trim()
        const existingDate = getAppointmentDateKey(getAppointmentScheduleDate(existingAppointment))
        const existingAppointmentId = String(existingAppointment?.data?.AppointmentID || '').trim()
        const existingProviderId = String(existingAppointment?.current?.Provider?.value || '').trim()

        return (
          existingStatus === 'canceled' &&
          existingPatientId === patientId &&
          existingDate === scheduleDate &&
          existingProviderId === providerId &&
          existingAppointmentId !== appointmentId
        )
      })
    })
  }

  // const handleRescheduleSubmit = async (appt, provider, date) => {

  //   let allChangedData = appt?.data

  //   let oldSchedulingData = appointments.filter((item) => item?.data?.AppointmentID === allChangedData?.AppointmentID)

  //   let current = {
  //     ...appt?.current,
  //     Provider: provider,
  //   }

  //   let data = {
  //     ...appt.data,
  //     AppointmentID: Date.now(),
  //     ProviderName: provider?.label,
  //     Status: 'Rescheduled',
  //     StartTime: formatDate(date),
  //     EndTime: formatDate(date).replace(':00', ':15').replace(':30', ':45') || oldSchedulingData[0]?.data.EndTime || allChangedData.EndTime,
  //   }

  //   const finalChanges = { data, current }

  //   let formateDateForAppointment = formatDate(date)
  //   const scheduleDate = formateDateForAppointment.split(' ')[0]
  //   const deleteAppintment = await handleDeleteScheduleAppointment(allChangedData.AppointmentID)
  //   const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', scheduleDate, provider?.value)
  //   const apiCallType = latestData.length > 0 ? 'UPDATE' : 'INSERT'
  //   const alreadyExists = latestData.some((appointment) => appointment.data.AppointmentID === allChangedData.AppointmentID)
  //   const updatedAppointments = alreadyExists ? latestData.map((appointment) => (appointment.data.AppointmentID === allChangedData.AppointmentID ? { data, current } : appointment)) : [...latestData, { data, current }]
  //   handleSubmit(updatedAppointments, apiCallType, finalChanges, 'Rescheduled')

  //   // setAppointments((appointments) => {
  //   //   const updatedAppointments = appointments.some((appointment) => appointment.data.AppointmentID === allChangedData.AppointmentID) ? appointments.map((appointment) => (appointment.data.AppointmentID === allChangedData.AppointmentID ? { data, current } : appointment)) : appointments
  //   //   handleSubmit(updatedAppointments, 'Rescheduled')
  //   //   return updatedAppointments
  //   // })

  //   // setSelectDate(null)
  //   // setSelectedProvider(null)
  // }
  const handleRescheduleSubmit = async (appt, provider, date) => {
    let allChangedData = appt?.data

    let oldSchedulingData = appointments.filter((item) => item?.data?.AppointmentID === allChangedData?.AppointmentID)

    let current = {}
    let data = {}
    if (allChangedData.patientSeen) {
      current = {
        ...appt?.current,
        Provider: provider,
      }

      data = {
        ...appt.data,
        AppointmentID: Date.now(),
        ProviderName: provider?.label,
        Status: 'Rescheduled',
        StartTime: formatDate(date),
        EndTime: formatDate(date).replace(':00', ':15').replace(':30', ':45') || oldSchedulingData[0]?.data.EndTime || allChangedData.EndTime,
      }
    } else {
      current = {
        ...appt?.current,
        Provider: provider,
      }

      data = {
        ...appt.data,
        patientSeen: true,
        AppointmentID: Date.now(),
        ProviderName: provider?.label,
        Status: 'Rescheduled',
        StartTime: formatDate(date),
        EndTime: formatDate(date).replace(':00', ':15').replace(':30', ':45') || oldSchedulingData[0]?.data.EndTime || allChangedData.EndTime,
      }
    }

    const finalChanges = { data, current }

    let formateDateForAppointment = formatDate(date)
    const scheduleDate = formateDateForAppointment.split(' ')[0]

    if (hasCanceledAppointmentOnDate(allChangedData?.PatientID, scheduleDate, provider?.value)) {
      toast.error(APPOINTMENT_ALREADY_CANCELLED_MESSAGE, toastConfig)
      return
    }

    // if (allChangedData.patientSeen) {
    //   const deleteAppintment = await handleDeleteScheduleAppointment(allChangedData.AppointmentID)
    // }
    if (allChangedData.patientSeen) {
      const isDeleted = await handleDeleteScheduleAppointment(allChangedData.AppointmentID)

      if (!isDeleted) {
        console.error('Delete failed. Stopping reschedule.')
        return
      }
    }
    const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', scheduleDate, provider?.value)
    const apiCallType = latestData.length > 0 ? 'UPDATE' : 'INSERT'
    const alreadyExists = latestData.some((appointment) => appointment.data.AppointmentID === allChangedData.AppointmentID)
    const updatedAppointments = alreadyExists ? latestData.map((appointment) => (appointment.data.AppointmentID === allChangedData.AppointmentID ? { data, current } : appointment)) : [...latestData, { data, current }]
    await handleSubmit(updatedAppointments, apiCallType, finalChanges, 'Rescheduled')

    // setAppointments((appointments) => {
    //   const updatedAppointments = appointments.some((appointment) => appointment.data.AppointmentID === allChangedData.AppointmentID) ? appointments.map((appointment) => (appointment.data.AppointmentID === allChangedData.AppointmentID ? { data, current } : appointment)) : appointments
    //   handleSubmit(updatedAppointments, 'Rescheduled')
    //   return updatedAppointments
    // })

    // setSelectDate(null)
    // setSelectedProvider(null)
  }

  const updateStatusDataBasedOnRescheduleDate = async (update, patientID, date) => {
    const providerID = selectedProvider?.value

    if (!providerID || !patientID) {
      toast.error('Patient data not found', toastConfig)
      return
    }

    const selectedDate = convertToYYYYMMDD(date)
    const isDataFound = await checkIfDataAvailableData(selectedDate)

    if (isDataFound && Object.keys(isDataFound).length > 0) {
      await appendPatientInTodaysList({ existingPatientData: isDataFound?.JsonData, providerId: providerID, patientId, id: isDataFound?.Id, date: selectedDate })
    } else {
      await addPatient({ providerId: providerID, patientId, date: selectedDate })
    }

    let result = localStorage.getItem('serverDataList')

    result = result ? JSON.parse(result) : {}

    if (!result[patientID]) {
      result[patientID] = {}
    }

    Object.keys(update || {}).forEach((keyType) => {
      result[patientID][keyType] = false
    })

    localStorage.setItem('serverDataList', JSON.stringify(result))
  }

  const updateCheckStatusData = async (update, patient, date) => {
    const providerID = selectedProvider?.value
    const patientID = patient?.PatientID

    if (!providerID || !patientID) {
      toast.error('Patient data not found', toastConfig)
      return
    }
    const selectedDate = getTodayDateKey()
    const isDataFound = await checkIfDataAvailableData(selectedDate)

    if (isDataFound && Object.keys(isDataFound).length > 0) {
      await updatePatientData({ existingPatientData: isDataFound?.JsonData, providerId: providerID, patientId: patientID, updates: update, id: isDataFound?.Id, date: selectedDate })
      await updateStatusDataBasedOnRescheduleDate({ AppointmentStatus: 'Scheduled' }, patient?.PatientID, date)
    }
  }

  const [showLoader, setShowLoader] = useState(false)
  const handleReschedule = async (patient, appt, date) => {
    setShowLoader(true)

    try {
      await updateCheckStatusData({ AppointmentStatus: 'Rescheduled' }, patient, date)
      let apptData = appointment.filter((item) => item.data.AppointmentID === appt)

      if (selectDate && selectedProvider && apptData.length > 0) {
        await handleRescheduleSubmit(apptData[0], selectedProvider, date)
      }
    } catch (error) {
      console.error('error while scheduling ', error)
    } finally {
      //  setShowLoader(false)
    }
  }

  // useEffect(() => {
  //   if (patientInfoData && patientInfoData.length > 0 && patientPassingAppointmentID) {
  //     openTreatmentNote(patientInfoData[0], patientPassingAppointmentID)
  //   }
  // }, [patientInfoData, patientPassingAppointmentID])

  // useEffect(() => {
  //   if (location.state) {
  //     history.replace({ ...location, state: undefined })
  //   }
  // }, [])

  useEffect(() => {
    const patientInfoData = JSON.parse(localStorage.getItem('patientInfoData'))
    const patientPassingAppointmentID = JSON.parse(localStorage.getItem('patientPassingAppointmentID'))
    const buttonContext = localStorage.getItem('noteButtonContext')
    const schedulerAppointmentDate = localStorage.getItem('schedulerAppointmentDate')

    if (buttonContext === 'scheduler' && schedulerAppointmentDate) {
      setFilterData((prev) => ({
        ...prev,
        scheduleDate: schedulerAppointmentDate,
      }))
    }
    if (patientInfoData && patientInfoData.length > 0 && patientPassingAppointmentID) {
      openTreatmentNote(patientInfoData[0], patientPassingAppointmentID)
    }
    setNoteButtonContext(buttonContext === 'scheduler' ? 'scheduler' : 'dashboard')
    localStorage.removeItem('patientInfoData')
    localStorage.removeItem('patientPassingAppointmentID')
    localStorage.removeItem('noteButtonContext')
    localStorage.removeItem('schedulerAppointmentDate')
  }, [])

  const safeParser = (data) => {
    try {
      return JSON.parse(data)
    } catch (e) {
      return data
    }
  }
  // to set the localstorage data to context when user come back from other page
  useEffect(() => {
    const setCreatingNewNoteLS = localStorage.getItem('setCreatingNewNote')
    const saveDiagnosisDataLS = localStorage.getItem('saveDiagnosisData')
    const setNoteStatusLS = localStorage.getItem('setNoteStatus')
    const setEditDataIdLs = localStorage.getItem('setEditDataId')
    const setChildFormDataLs = localStorage.getItem('setChildFormData')
    const setNoteIDLS = localStorage.getItem('setNoteID')
    const setDataCallTypeLS = localStorage.getItem('setDataCallType')
    const patientDataStatusChange = localStorage.getItem('patientDataStatusChange')
    const setShowPatientInfoLS = localStorage.getItem('setShowPatientInfo')
    const setPatientModalVisibleLS = localStorage.getItem('setPatientModalVisible')
    const setChildFormDataStatusLS = localStorage.getItem('setChildFormDataStatus')
    const childFormdataLS = JSON.parse(localStorage.getItem('childFormdata'))
    const patientDataLS = JSON.parse(localStorage.getItem('patientData'))
    const patientId = localStorage.getItem('patientId')

    if (patientDataLS) {
      setPatientData(patientDataLS)
      setRowClicked(patientDataLS)
    }

    // if (setCreatingNewNoteLS === 'true') {
    //   setCreatingNewNote(true);
    //   localStorage.removeItem("setCreatingNewNote");
    // }

    if (saveDiagnosisDataLS) {
      saveDiagnosisData({
        ...patientData,
        Status: saveDiagnosisDataLS,
      })
    }

    if (setNoteStatusLS) {
      setNoteStatus('Follow Up')
      localStorage.removeItem('setNoteStatus')
    }

    if (setEditDataId) {
      setEditDataId(setEditDataIdLs)
      localStorage.removeItem('setEditDataId')
    }

    if (setChildFormDataLs) {
      setChildFormData({
        ...childFormdataLS,
        Status: setChildFormDataLs,
      })
      localStorage.removeItem('setChildFormData')
    }

    if (setNoteIDLS) {
      setNoteID(setNoteIDLS)
      localStorage.removeItem('setNoteID')
    }

    if (setDataCallTypeLS) {
      setDataCallType(setDataCallTypeLS)
      localStorage.removeItem('setDataCallType')
    }

    if (patientDataStatusChange) {
      if (patientData?.Status === 'Follow Up') {
        //this is for case if the note id is 0 and patient created as followup then the hpi should not show, it should show the subjective, so for that we need to set the notestatus as followup.
        setNoteStatus(patientDataStatusChange)
      }
    }

    if (setShowPatientInfoLS !== null && setShowPatientInfoLS !== undefined) {
      setShowPatientInfo(true)
    }

    if (setPatientModalVisibleLS !== null && setPatientModalVisibleLS !== undefined) {
      setPatientModalVisible(JSON.parse(setPatientModalVisibleLS))
    }

    if (patientId) {
      setPatientID(JSON.parse(patientId))
      setPatientIDClicked(JSON.parse(patientId))
    }

    localStorage.removeItem('saveDiagnosisData')
    localStorage.removeItem('patientDataStatusChange')
    localStorage.removeItem('patientData')
    localStorage.removeItem('childFormdata')
    localStorage.removeItem('SyncAppointmentData')
    localStorage.removeItem('setChildFormDataStatus')
    localStorage.removeItem('setPatientModalVisible')
    localStorage.removeItem('setShowPatientInfo')
    localStorage.removeItem('patientId')
  }, [])

  // for edit note in new
  useEffect(() => {
    const setEditDataIdLocal = safeParser(localStorage.getItem('setEditDataIdLocal'))
    const setDataCallTypeLocal = safeParser(localStorage.getItem('setDataCallTypeLocal'))
    const setNoteStatusLocal = safeParser(localStorage.getItem('setNoteStatusLocal'))
    const setPatientModalVisibleLocal = safeParser(localStorage.getItem('setPatientModalVisibleLocal'))
    const setNoteIDLocal = safeParser(localStorage.getItem('setNoteIDLocal'))
    const setPatientIDClickedLocal = safeParser(localStorage.getItem('setPatientIDClickedLocal'))
    const setRowClickedLocal = safeParser(localStorage.getItem('setRowClickedLocal'))
    const setPatientAppointmentIDLocal = safeParser(localStorage.getItem('setPatientAppointmentIDLocal'))

    if (setEditDataIdLocal !== null && setEditDataIdLocal !== undefined) {
      setEditDataId(setEditDataIdLocal)
    }
    if (setDataCallTypeLocal !== null && setDataCallTypeLocal !== undefined) {
      setDataCallType(setDataCallTypeLocal)
    }
    if (setNoteStatusLocal !== null && setNoteStatusLocal !== undefined) {
      setNoteStatus(setNoteStatusLocal)
    }
    if (setNoteIDLocal !== null && setNoteIDLocal !== undefined) {
      setNoteID(setNoteIDLocal)
    }
    if (setPatientIDClickedLocal !== null && setPatientIDClickedLocal !== undefined) {
      setPatientIDClicked(setPatientIDClickedLocal)
    }
    if (setRowClickedLocal !== null && setRowClickedLocal !== undefined) {
      setRowClicked(setRowClickedLocal)
    }
    if (setPatientIDClickedLocal !== null && setPatientIDClickedLocal !== undefined) {
      setPatientID(setPatientIDClickedLocal)
    }
    if (setPatientAppointmentIDLocal !== null && setPatientAppointmentIDLocal !== undefined) {
      setPatientAppointmentID(setPatientAppointmentIDLocal)
    }
  }, [])

  // console.log('groupedUpdatedFilteredPatients', groupedUpdatedFilteredPatients, filteredPatientData)
  const hasActiveSearch = Boolean(normalizeSearchValue(filterData.searchValue))
  const hasEmptyGroupedAppointments = !groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0
  const shouldShowAppointmentsLoader = isPageLoading || (!hasActiveSearch && hasEmptyGroupedAppointments && !hasNotAppointment && (!isTreatmentNotesReady || !isAppointmentGroupingReady))
  return (
    <div>
      {showPatientInfo ? (
        <PatientInfoSecond
          creatingNewNote={creatingNewNote}
          saveDiagnosisData={saveDiagnosisData}
          noteStatus={noteStatus}
          patientID={patientIDClicked}
          patientData={rowClicked}
          setRowClicked={setRowClicked}
        // dataCallType={dataCallType}
        // setEditDataId={setEditDataId}
        // setDataCallType={setDataCallType}
        // noteID={noteID}
        // setDataId={setDataId}
        // handleAddNoteId={handleAddNoteId}
        // appointments={appointments}
        />
      ) : setDataId ? (
        <PatientInfoSecond
          creatingNewNote={creatingNewNote}
          saveDiagnosisData={saveDiagnosisData}
          noteStatus={noteStatus}
          patientID={patientIDClicked}
          patientData={rowClicked}
          setRowClicked={setRowClicked}
          dataCallType={dataCallType}
          setDataCallType={setDataCallType}
          setEditDataId={setEditDataId}
          noteID={noteID}
          setDataId={setDataId}
          handleAddNoteId={handleAddNoteId}
          appointments={appointments}
        />
      ) : (
        <div className="position-relative patient-theme-page">
          <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme">
            <div>
              <div
                className="patient-theme-toolbar-shell"
              >
                <CCardBody className="p-0">
                  <div className="d-flex align-items-center justify-content-between gap-3 ">
                    <div className="page-header">
                      <div className="d-flex align-items-center gap-2 patient-theme-toolbar flex-wrap">
                        <div className="search-input search-dark patient-theme-search ui-search-control" style={{ minWidth: '380px', width: 'min(100%, 380px)' }}>
                          <SearchIcon />
                          <input
                            onChange={(e) => {
                              setFilterData((prev) => ({ ...prev, searchValue: e.target.value }))
                            }}
                            value={filterData.searchValue}
                            type="text"
                            placeholder="Search by Patient, Provider or Facility..."
                          />
                        </div>
                        <div className="position-relative ">
                          <Button className="d-flex align-items-center gap-2 patient-theme-filter-button" variant="outlined" size="large" onClick={() => setShowFilter(!showFilter)}>
                            <FunnelPlotOutlined />
                            Filter
                          </Button>

                          {showFilter && (
                            <motion.div
                              initial={{ opacity: 0, y: 4 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: 4 }}
                              transition={{ duration: 0.3, ease: 'easeInOut' }}
                              style={{
                                width: '400px',
                                zIndex: 50,
                              }}  
                              className="position-absolute gap-1 d-flex flex-column top-full left-0 z-10 p-4 patient-theme-filter-popover dashboard-dark-filter-popover"
                            >
                              <div>
                                <CFormLabel>Select Facility</CFormLabel>
                                <AppSelect
                                  placeholder="Select"
                                  name="facility"
                                  options={facilities}
                                  value={facilities.filter((fac) => filterData.facility.includes(fac.value))}
                                  isMulti
                                  isClearable
                                  onChange={(selectedOptions) =>
                                    setFilterData((prev) => ({
                                      ...prev,
                                      facility: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                    }))
                                  }
                                />
                              </div>

                              <div className="mt-2">
                                <CFormLabel>Select Patient Status</CFormLabel>
                                <AppSelect
                                  name="status"
                                  isMulti
                                  placeholder="Select"
                                  options={selectStatusOption}
                                  isClearable
                                  value={selectStatusOption.filter((option) => filterData.status.includes(option.value))}
                                  onChange={(selectedOptions) =>
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                    }))
                                  }
                                />
                              </div>
                              <div className="mt-2">
                                <CFormLabel>Select Appointment Status</CFormLabel>
                                <AppSelect
                                  name="status"
                                  isMulti
                                  placeholder="Select"
                                  options={selectAppointmentStatus}
                                  isClearable
                                  value={selectAppointmentStatus.filter((option) => filterData.appointmentStatus.includes(option.value))}
                                  onChange={(selectAppointmentStatus) =>
                                    setFilterData((prev) => ({
                                      ...prev,
                                      appointmentStatus: selectAppointmentStatus ? selectAppointmentStatus.map((option) => option.value) : [],
                                    }))
                                  }
                                />
                              </div>

                              <div className="mt-2">
                                <CFormLabel>Select Providers</CFormLabel>
                                <AppSelect
                                  name="status"
                                  isMulti
                                  placeholder="Select Providers"
                                  isClearable
                                  options={providerList.map((provider) => ({
                                    value: provider.Name,
                                    label: provider.Name,
                                  }))}
                                  value={providerList.filter((provider) => filterData.providers.includes(provider.Name)).map((provider) => ({ value: provider.Name, label: provider.Name }))}
                                  onChange={(selectedOptions) =>
                                    setFilterData((prev) => ({
                                      ...prev,
                                      providers: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                    }))
                                  }
                                />
                              </div>

                              <div className="mt-2" style={{ position: 'relative', display: 'inline-block' }}>
                                <CFormLabel>Select DOB</CFormLabel>
                                <div>
                                  <CustomDatePickingFormat
                                    value={filterData.date || ''}
                                    aria-describedby="exampleFormControlInputHelpInline"
                                    onChange={(e) => {
                                      setFilterData((p) => ({
                                        ...p,
                                        date: e,
                                      }))
                                    }}
                                  />
                                </div>
                                {/* <CFormInput
                                  type="date"
                                  color="primary"
                                  value={filterData.date || ''}
                                  aria-describedby="exampleFormControlInputHelpInline"
                                  onChange={(e) => {
                                    setFilterData((p) => ({
                                      ...p,
                                      date: e.target.value, // Keep the date in "YYYY-MM-DD" format
                                    }))
                                  }}
                                /> */}
                              </div>

                              <Button className="mt-2 patient-theme-filter-button" onClick={() => setShowFilter(false)} variant="outlined">
                                Close
                              </Button>
                            </motion.div>
                          )}
                        </div>
                      </div>

                      <div className="patient-theme-date-field">
                        <div className="patient-theme-date-shell">
                          <CustomDatePickingFormat
                            value={filterData.scheduleDate || ''}
                            aria-describedby="exampleFormControlInputHelpInline"
                            onChange={(e) => {
                              setFilterData((p) => ({
                                ...p,
                                scheduleDate: e, // Keep the date in "YYYY-MM-DD" format
                              }))
                            }}
                          />
                        </div>

                        {/* <CFormInput
                                style={{
                                  borderColor:"#1A76D2",
                                  color:"#1A76D2",
                                  background:"none",
                                  minHeight:"42.5px"

                                }}
                                  type="date"
                                  color="primary"
                                  value={filterData.scheduleDate || ''}
                                  aria-describedby="exampleFormControlInputHelpInline"
                                  onChange={(e) => {
                                    setFilterData((p) => ({
                                      ...p,
                                      scheduleDate: e.target.value, // Keep the date in "YYYY-MM-DD" format
                                    }))
                                  }}
                                /> */}
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <div className="d-flex align-items-center gap-2 mx-3">
                        <div className="display-total-patient">
                          <span className="mx-1">{patientCount}</span> Appointments
                        </div>
                        <div className="display-total-patient">
                          <span className="mx-1">{patientInfoCount?.newPatient || 0}</span> NP
                        </div>
                        <div className="display-total-patient">
                          <span className="mx-1">{patientInfoCount?.followUp || 0}</span> FU
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          setBoxView('list')
                        }}
                        className={`d-flex align-items-center justify-content-center patient-theme-view-toggle appointment-view-toggle ${boxView === 'list' ? 'patient-theme-view-toggle--active' : ''}`}
                      >
                        <AlignLeft size={16} strokeWidth={1.25} />
                        <div className="patient-theme-view-toggle__label">List</div>
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setBoxView('table')
                        }}
                        className={`d-flex align-items-center justify-content-center patient-theme-view-toggle appointment-view-toggle ${boxView === 'table' ? 'patient-theme-view-toggle--active' : ''}`}
                      >
                        <Table2 size={16} strokeWidth={1.25} />
                        <div className="patient-theme-view-toggle__label">Details</div>
                      </button>
                    </div>
                  </div>
                </CCardBody>
              </div>
            </div>

            {boxView === 'table' && (
              <motion.div className="custom-card-wrapper patient-theme-card-grid">
                {updatedFilteredPatients.map((patient, index) => {
                  // const patientID = appt?.current?.Patient?.value

                  // const patient = updatedFilteredPatients.find((p) => p.PatientID === patientID)

                  // if (!patient) return null

                  // const status = appt?.data?.Status
                  // const scheduleBy = appt?.data?.ScheduleBy
                  // const type = appt?.data?.Type
                  // const isInFacility = appt?.data?.isInFacility
                  // const priorAuth = appt?.data?.otherDetails?.priorAuth?.isRequired
                  // let priorAuthTime = 0

                  // if (priorAuth) {
                  //   priorAuthTime = parseInt(appt?.data?.otherDetails?.priorAuth?.details?.noOfTimes || '0', 10)
                  // }

                  // const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
                  // const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

                  // if (!isScheduledOrRescheduled || !isManualOrFollowUp) return null

                  // const providerName = appt?.current?.Provider?.label
                  // const scheduleDate = appt?.data?.StartTime?.split(' ')[0]
                  // const Type = appt?.data?.Type

                  // let facilityDays = locations?.filter((facility) => facility.Name === patient.FacilityName)[0]

                  // let allowedDates = findDates(facilityDays?.Days.split(',') || [])

                  return (
                    <>
                      <motion.div key={`${appointment.length}-${index}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }} className="custom-card ">
                        <div className="card-header ">
                          <div>
                            <div className="d-flex align-items-center gap-2">
                              <p className="name-block">
                                {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                                <span
                                  className={`patient-theme-status-badge ${patient?.data?.Type === 'New'
                                    ? 'patient-theme-status-badge--new'
                                    : patient?.data?.Type === 'Follow Up'
                                      ? 'patient-theme-status-badge--followup'
                                      : 'patient-theme-status-badge--readmit'}`}
                                >
                                  ({patient?.data?.Type === 'Follow Up' ? 'Follow Up' : patient?.data?.Type === 'New' ? 'New Patient' : patient?.data?.Type === 'Re Admit' ? 'Re Admit' : ''})
                                </span>
                              </p>
                            </div>
                            <div className="bullet-points">
                              <span>{patient.Gender}</span>
                              {patient?.DOB && (
                                <span>
                                  DOB:{' '}
                                  {new Date(patient?.DOB).toLocaleDateString('en-US', {
                                    month: '2-digit',
                                    day: '2-digit',
                                    year: 'numeric',
                                  })}{' '}
                                </span>
                              )}
                              <span>{patient.Age} Years</span>
                            </div>
                          </div>
                                              <div
                                                className="button-wrapper"
                                                style={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: '0.5rem',
                                                }}
                                              >
                            {/* <a href="/home/scheduler">
                              <CButton variant="outline" color="warning" className="px-2">
                                <HiPencil size={20} />
                              </CButton>
                            </a> */}
                            <CButton onClick={() => setShowPatientAppointmentId(patient?.data?.AppointmentID)} variant="outline" color="success" className="px-2">
                              <HiEye size={20} />
                            </CButton>
                            <CButton onClick={() => openTreatmentNote(patient, patient?.data?.AppointmentID)} variant="outline" color="dark" className="px-2">
                              <FilePenLineIcon size={20} />
                            </CButton>
                            <ActionDropdown
                              patient={patient}
                              index={index}
                              handleAppointment={handleAppointment}
                              openRescheduleModal={openRescheduleModal}
                            />
                          </div>
                        </div>
                        <div className="contact-wrapper w-100 d-flex px-3">
                          <div>
                            <p className="title">Provider Name</p>
                            <p className="value">{patient?.current?.Provider?.label}</p>
                          </div>
                          <div>
                            <p className="title">Schedule Date</p>
                            <p className="value">{patient?.data?.StartTime?.split(' ')[0]}</p>
                          </div>
                          <div>
                            <p className="title">Note Status</p>
                            <p className="value">{patient.noteStatus === 'Not Started' || patient.noteStatus === 'Not Created' ? 'Not Created' : patient.noteStatus === 'Draft' && patient.noteFlag === 'true' ? 'Provider Draft' : patient.noteStatus}</p>
                          </div>
                        </div>
                        <div className="card-footer w-100 d-flex justify-content- align-items-start">
                          <div className="facility mw-100">
                            <p className="title">FACILITY NAME</p>
                            <p className="value">
                              {patient.FacilityName}
                              {patient.facilityParentCompany && ` - ${patient.facilityParentCompany}`}
                            </p>
                          </div>
                          <div className="room-count">
                            <p className="title">ROOM</p>
                            <p className="value">{patient.Room ?? ''}</p>
                          </div>
                        </div>
                      </motion.div>
                    </>
                  )
                })}
              </motion.div>
            )}

            {boxView === 'list' && (
              <div className="mt-3 patient-theme-list-shell">
                {hasEmptyGroupedAppointments ? (
                  <h6 className="d-flex justify-content-center text-secondary">No Patient found</h6>
                ) : (
                  <CAccordion alwaysOpen className="border-bottom-0 m-0 w-100 border-0 p-0 patient-theme-accordion">
                    {Object.entries(groupedUpdatedFilteredPatients).map(([date, providers], dateIdx) => {
                      return (
                        <div className="testdiv mb-2" key={date}>
                          <div className="border-bottom-0 border-0">
                            <div className="border-bottom-0 border-0 mb-2 patient-theme-date-heading">{date}</div>

                            <div className="border-bottom-0 border-to-add-facility card-header bg-none d-flex w-100 border-0 p-0 shadow-sm patient-theme-provider-group">
                              <CAccordion alwaysOpen className="border-bottom-0 m-0 w-100 border-0 p-0 patient-theme-accordion">
                                {Object.entries(providers).map(([providerName, providerObj], provIdx) => {
                                  const { count = 0, facilities = {} } = providerObj

                                  return (
                                    <CAccordionItem itemKey={provIdx + 1} key={providerName} className="patient-theme-accordion-item">
                                      <CAccordionHeader className="patient-theme-accordion-header">
                                        {providerName} ({count})
                                      </CAccordionHeader>

                                      <CAccordionBody>
                                        <CAccordion alwaysOpen className="border-bottom-0 m-0 w-100 border-0 p-0 patient-theme-accordion">
                                          {Object.keys(facilities).length === 0 ? (
                                            <div className="px-3 patient-theme-empty-state">No Facility Available</div>
                                          ) : (
                                            Object.entries(facilities).map(([facilityName, patients], facIdx) => {
                                              const parentCompanyName = patients.find((patient) => patient?.facilityParentCompany)?.facilityParentCompany || ''

                                              return (
                                                <CAccordionItem disabled className="border-bottom-0 mb-3 shadow-sm border patient-theme-facility-item" key={`fac-${facIdx}`}>
                                                  <CAccordionHeader className="patient-theme-accordion-header patient-theme-facility-header">
                                                    <div className="d-flex align-items-center gap-2 flex-wrap w-100">
                                                      <span>
                                                        {facilityName} {parentCompanyName && `- ${parentCompanyName}`}
                                                      </span>
                                                    </div>
                                                  </CAccordionHeader>

                                                  <CAccordionBody className="border-bottom-0 border-0 py-0 p-0">
                                                    <CTable className="mb-0 border-bottom-0 border-0 patient-theme-table">
                                                      <CTableBody>
                                                        {patients.map((patient, index) => {
                                                          return (
                                                            <CTableRow
                                                              className={`order-0 px-4 ${patient?.data?.Type === 'New' ? 'NP' : patient?.data?.Type === 'Follow Up' ? 'FU' : patient?.data?.Type} patient-row-list`}
                                                              key={patient.PatientID}
                                                              style={{ verticalAlign: 'middle', padding: '20px', top: 0 }}
                                                            >
                                                              <CTableDataCell className={` border-bottom-0 border-0`} scope="row" style={{ width: '100%' }}>
                                                                <div
                                                                  style={{
                                                                    display: 'grid',
                                                                    gridTemplateColumns: '340px minmax(0, 1fr)',
                                                                    alignItems: 'center',
                                                                    gap: '16px',
                                                                    width: '100%',
                                                                  }}
                                                                >
                                                                  <span className="d" style={{ paddingLeft: '20px', minWidth: 0 }}>
                                                                    <span className="patient-name-fixed">{patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}</span>
                                                                  </span>
                                                                  <div
                                                                    style={{
                                                                      display: 'flex',
                                                                      alignItems: 'center',
                                                                      gap: '12px',
                                                                      minWidth: 0,
                                                                    }}
                                                                  >
                                                                    <span className="room-pill patient-theme-fixed-pill" style={{ margin: 0, width: '180px', minWidth: '180px', maxWidth: '180px' }}>
                                                                      Room No: {patient?.Room}
                                                                    </span>
                                                                    <span className="notestatus-pill patient-theme-fixed-pill" style={{ margin: 0, width: '170px', minWidth: '170px', maxWidth: '170px' }}>
                                                                      Note Status: {patient?.noteStatus === 'Draft' && patient?.noteFlag === 'true' ? 'Provider Draft' : patient?.noteStatus}
                                                                    </span>
                                                                    <span className="schedule-pill patient-theme-fixed-pill" style={{ margin: 0, width: '180px', minWidth: '180px', maxWidth: '180px' }}>
                                                                      Scheduled Date: {patient?.data?.StartTime?.split(' ')[0]}
                                                                    </span>
                                                                    {patient?.data?.Status !== 'Scheduled' && (
                                                                      <span className="appointmentStatus-pill patient-theme-fixed-pill" style={{ margin: 0 }}>
                                                                        {patient?.data?.Status}
                                                                      </span>
                                                                    )}
                                                                    {patient?.patientSeen === false && (
                                                                      <span className="schedule1-pill" style={{ margin: 0 }}>
                                                                        Not Seen : {patient?.notSeenReason}
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </CTableDataCell>
                                                              <CTableDataCell className="d-flex justify-content-end border-bottom-0 border-0">
                                                      <div
                                                        className="button-wrapper"
                                                        style={{
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          gap: '0.5rem',
                                                        }}
                                                      >
                                                                  <CButton onClick={() => setShowPatientAppointmentId(patient?.data?.AppointmentID)} variant="outline" color="success" className="px-2">
                                                                    <HiEye size={20} />
                                                                  </CButton>
                                                                  <CButton onClick={() => openTreatmentNote(patient, patient?.data?.AppointmentID)} variant="outline" color="dark" className="px-2">
                                                                    <FilePenLineIcon size={20} />
                                                                  </CButton>
                                                                  <ActionDropdown patient={patient} index={index} handleAppointment={handleAppointment} openRescheduleModal={openRescheduleModal} />
                                                                </div>
                                                              </CTableDataCell>
                                                            </CTableRow>
                                                          )
                                                        })}
                                                      </CTableBody>
                                                    </CTable>
                                                  </CAccordionBody>
                                                </CAccordionItem>
                                              )
                                            })
                                          )}
                                        </CAccordion>
                                      </CAccordionBody>
                                    </CAccordionItem>
                                  )
                                })}
                              </CAccordion>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </CAccordion>
                )}
              </div>
            )}

            <CModal
              className="patient-theme-modal"
              backdrop="static"
              visible={Boolean(showRescheduleModal)}
              onClose={() => {
                setShowRescheduleModal(false)
                setSelectDate(null)
                setSelectedProvider(null)
              }}
              size="md"
            >
              <CModalHeader closeButton>
                <CModalTitle>Reschedule Appointment</CModalTitle>
              </CModalHeader>
              <CModalBody>
                {rescheduleData?.patient &&
                  (() => {
                    const patient = rescheduleData.patient
                    const facilityDays = locations?.find((facility) => facility.Name === patient?.FacilityName) || null

                    return (
                      <RescheduleDatePicker
                        providers={rescheduleProviders}
                        selectedDate={selectDate}
                        selectedProvider={selectedProvider}
                        setSelectDate={setSelectDate}
                        setSelectedProvider={setSelectedProvider}
                        facilityDays={facilityDays}
                      />
                    )
                  })()}
              </CModalBody>
              <CModalFooter>
                <CButton
                  color="secondary"
                  variant="outline"
                  className="dashboard-dark-modal-button"
                  onClick={() => {
                    setShowRescheduleModal(false)
                    setSelectDate(null)
                    setSelectedProvider(null)
                    setShowLoader(false)
                  }}
                >
                  Close
                </CButton>
                <CButton className="dashboard-dark-modal-button dashboard-dark-modal-button--primary" disabled={selectedProvider?.value ? false : true} onClick={() => handleReschedule(rescheduleData?.patient, rescheduleData?.appointmentID, selectDate)}>
                  {showLoader ? (
                    <>
                      <CSpinner size="sm" className="me-2" /> Processing...
                    </>
                  ) : (
                    'Re-schedule'
                  )}
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal className="patient-theme-modal" size="lg" backdrop="static" visible={patientModelVisible} onClose={() => setPatientModalVisible(false)}>
              {/* patientData, patientID, setPatientModalVisible, setDataCallType, setShowPatientInfo, setEditDataId, setNoteID, patientSelected, childformData, setChildFormData, saveDiagnosisData */}
              <CModalBody className="view-data-modal" style={{ padding: '2rem', borderRadius: '2rem', overflow: 'auto' }}>
                {
                  <PatientPopup
                    creatingNewNote={creatingNewNote}
                    setCreatingNewNote={setCreatingNewNote}
                    noteStatus={noteStatus}
                    setNoteStatus={setNoteStatus}
                    patientSelected={patientSelected}
                    setNoteID={setNoteID}
                    childformData={childformData}
                    setChildFormData={setChildFormData}
                    saveDiagnosisData={saveDiagnosisData}
                    patientID={patientIDClicked}
                    patientData={rowClicked}
                    noteStructureRef={noteStructureRef}
                    setPatientModalVisible={setPatientModalVisible}
                    dataCallType={dataCallType}
                    setDataCallType={setDataCallType}
                    setEditDataId={setEditDataId}
                    setShowPatientInfo={setShowPatientInfo}
                    setAllSelectedDiagnosis={setAllSelectedDiagnosis}
                    patientAppointmentID={patientAppointmentID}
                    appointment={appointment}
                    viewPatientDetail={viewPatientDetail}
                    handleAddNoteId={handleAddNoteId}
                    allAppointment={allAppointment}
                    noteButtonContext={noteButtonContext}
                  />
                }
              </CModalBody>
              <CModalFooter>
                <Button className="patient-theme-filter-button" variant="outlined" onClick={() => setPatientModalVisible(false)}>
                  Close
                </Button>
              </CModalFooter>
            </CModal>

            <CModal className="patient-theme-modal" visible={deleteVisible} onClose={() => setDeleteVisible(false)}>
              <CModalHeader>
                <CModalTitle>Warning</CModalTitle>
              </CModalHeader>
              <CModalBody>
                <p>Are you sure you want to delete?</p>
              </CModalBody>

              <CModalFooter>
                <CButton
                  className="dashboard-dark-modal-button"
                  onClick={() => {
                    setDeleteVisible(false)
                  }}
                >
                  Close
                </CButton>
                <CButton onClick={handleDeletePatient} className="dashboard-dark-modal-button dashboard-dark-modal-button--primary">
                  Delete
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal
              className="patient-theme-modal rounded"
              alignment="center"
              onClose={() => {
                setShowPatientAppointmentId(null)
              }}
              visible={showPatientAppointmentId !== null}
              aria-labelledby="VerticallyCenteredExample"
            >
              <CModalHeader>
                <CModalTitle className="" id="VerticallyCenteredExample">
                  Appointment Details
                </CModalTitle>
              </CModalHeader>
              <CModalBody className="w-100">
                <CNav className="d-flex align-items-center justify-content-center w-100" variant="pills" role="tablist">
                  <CNavItem>
                    <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)}>
                      Insurances
                    </CNavLink>
                  </CNavItem>
                  <CNavItem className="">
                    <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)}>
                      Other Details
                    </CNavLink>
                  </CNavItem>
                </CNav>
                <CTabContent>
                  <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeKey === 1}>
                    <div style={{ widht: '100%!important' }} className="d-flex py-2 w-100 align-items-center gap-4 justify-content-between flex-wrap w-full">
                      {patientAppointment?.length > 0 ? (
                        <div>
                          {patientAppointment
                            .filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled' || item.data.Status === 'Canceled')
                            .map((item, idx) => {
                              return (
                                <div key={idx} className="w-100">
                                  <div
                                    style={{
                                      display: 'grid!important',
                                      gridTemplateColumns: '1fr 1fr 1fr',
                                      gridGap: '10px',
                                    }}
                                    className="w-100"
                                  >
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Prior Auth Number: </p>
                                      <p className="fw-light">{item?.data?.otherDetails?.priorAuth?.details?.priorAuthNo ?? '-'}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Number of times: </p>
                                      <p className="fw-light">{item?.data?.otherDetails?.priorAuth?.details?.noOfTimes ?? '-'}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Expiry Date: </p>
                                      <p className="fw-light">
                                        {item?.data?.otherDetails?.priorAuth?.details?.expDate
                                          ? new Date(item.data.otherDetails.priorAuth.details.expDate).toLocaleDateString('en-US', {
                                            month: '2-digit',
                                            day: '2-digit',
                                            year: 'numeric',
                                          })
                                          : '-'}
                                      </p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Co-Sign Required: </p>
                                      <p className="fw-light">{item?.data?.otherDetails?.isCoSignRequired === true ? 'Yes' : item?.data?.otherDetails?.isCoSignRequired === false ? 'No' : '-'}</p>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                      ) : (
                        <div>
                          <div className="w-100">
                            <div
                              style={{
                                display: 'grid!important',
                                gridTemplateColumns: '1fr 1fr 1fr',
                                gridGap: '10px',
                              }}
                              className="w-100"
                            >
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Prior Auth Number: </p>
                                <p className="fw-light">{'-'}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Number of times: </p>
                                <p className="fw-light">{'-'}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Expiry Date: </p>
                                <p className="fw-light">{'-'}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Co-sign Required: </p>
                                <p className="fw-light">{'-'}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </CTabPane>
                  <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeKey === 2}>
                    <div style={{ widht: '100%!important' }} className="d-flex py-2 w-100 align-items-center gap-4 justify-content-between flex-wrap w-full">
                      {patientAppointment.length > 0 ? (
                        <div>
                          {patientAppointment
                            .filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')
                            .map((item, idx) => {
                              return (
                                <div key={idx} className="w-100">
                                  <div
                                    style={{
                                      display: 'grid!important',
                                      gridTemplateColumns: '1fr 1fr 1fr',
                                      gridGap: '10px',
                                    }}
                                    className="w-100"
                                  >
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Insurance Type</p>
                                      <p className="fw-light">{item?.data?.Insurance?.Type ?? ''}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Insurance Sub Type</p>
                                      <p className="fw-light">{item?.data?.Insurance?.SubType ?? ''}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Policy Number: </p>
                                      <p className="fw-light">{item?.data?.Insurance?.PolicyNumber ?? ''}</p>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                      ) : (
                        <div>
                          <div className="w-100">
                            <div
                              style={{
                                display: 'grid!important',
                                gridTemplateColumns: '1fr 1fr 1fr',
                                gridGap: '10px',
                              }}
                              className="w-100"
                            >
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Policy Number: </p>
                                <p className="fw-light">{''}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Insurance Type</p>
                                <p className="fw-light">{''}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Insurance Sub Type</p>
                                <p className="fw-light">{''}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </CTabPane>
                </CTabContent>
              </CModalBody>
            </CModal>

            <CModal className="patient-theme-modal" visible={cancelModel} onClose={() => setCancelModel(false)}>
              <CModalHeader>
                <CModalTitle>Cancel Appointment</CModalTitle>
              </CModalHeader>

              <CModalBody>
                <CFormTextarea
                  id="cancelReason"
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                  placeholder="Type your cancellation reason here..."
                  className="rounded-3 ui-form-textarea patient-theme-cancel-textarea"
                  style={{ height: '140px', padding: '1rem', fontSize: '1rem' }}
                />
              </CModalBody>

              <CModalFooter>
                <CButton color="secondary" variant="outline" onClick={() => setCancelModel(false)}>
                  Close
                </CButton>
                <CButton onClick={() => handleAppointmentCancel('Canceled')} className="dashboard-dark-modal-button dashboard-dark-modal-button--primary">
                  Proceed to Cancel
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal className="patient-theme-modal" visible={finishModel} onClose={() => setFinishModel(false)}>
              <CModalHeader>
                <CModalTitle>Finish Appointment</CModalTitle>
              </CModalHeader>
              <CModalBody>
                <p>Are you sure you want to finish this appointment?</p>
              </CModalBody>

              <CModalFooter>
                <CButton
                  color="secondary"
                  variant="outline"
                  onClick={() => {
                    setFinishModel(false)
                  }}
                >
                  Close
                </CButton>
                <CButton
                  className="dashboard-dark-modal-button dashboard-dark-modal-button--primary"
                  onClick={() => {
                    handleAppointmentSubmit('Finish')
                  }}
                >
                  Finish Appointment
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal className="patient-theme-modal" visible={deleteModel} onClose={() => setDeleteModel(false)}>
              <CModalHeader>
                <CModalTitle>Delete Appointment</CModalTitle>
              </CModalHeader>
              <CModalBody>
                <p>Are you sure you want to Delete this appointment?</p>
              </CModalBody>

              <CModalFooter>
                <CButton
                  color="secondary"
                  variant="outline"
                  onClick={() => {
                    setDeleteModel(false)
                  }}
                >
                  Cancel
                </CButton>
                <CButton
                  color="danger"
                  className="hrm-modal-danger-btn"
                  onClick={() => {
                    handleDeleteSubmit()
                  }}
                >
                  Delete
                </CButton>
              </CModalFooter>
            </CModal>
          </div>

          <Pageloader isLoading={shouldShowAppointmentsLoader} />

          {/* <Pageloader isLoading={(!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0) && filteredPatientData.length === 0} /> */}
        </div>
      )}
    </div>
  )
}
export default Appointments2
